import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  tr: {
    translation: {
      // Common
      "backToHome": "Ana Sayfaya Dön",
      "back": "Geri",
      
      // Register Page
      "register": "Kayıt Ol",
      "registerTitle": "Hemen Başlayın",
      "registerDescription": "Hesabınızı oluşturun ve ekip verimliliğinizi artırın",
      "companyName": "Firma Adı",
      "companyNamePlaceholder": "örn. Acme Yazılım A.Ş.",
      "industry": "Sektör",
      "selectIndustry": "Sektör seçin",
      "nameSurname": "Ad Soyad",
      "namePlaceholder": "Ahmet Yılmaz",
      "phoneNumber": "Telefon Numarası",
      "phonePlaceholder": "+90 555 123 4567",
      "phoneHelpText": "Telefon numaranızı uluslararası formatta girin",
      "passwordHelpText": "En az 6 karakter",
      "registerButton": "Hesap Oluştur",
      "registering": "Oluşturuluyor...",
      "registerSuccess": "Kayıt başarılı!",
      "registerFailed": "Kayıt başarısız oldu",
      "fillAllFields": "Lütfen tüm alanları doldurun",
      "companyInfo": "Firma Bilgileri",
      "adminUserInfo": "Admin Kullanıcı Bilgileri",
      "createCompanyButton": "Firmayı Oluştur ve Başla",
      "alreadyHaveAccount": "Zaten hesabınız var mı?",
      "loginLink": "Giriş Yapın",
      "startInstantly": "Anında Başlayın",
      "startInstantlyDesc": "Kurulum gerekmez, hemen kullanmaya başlayın",
      "free14Days": "14 Gün Ücretsiz",
      "free14DaysDesc": "Kredi kartı gerekmez, risk yok",
      "fullFeatures": "Tam Özellikler",
      "fullFeaturesDesc": "Tüm premium özelliklere tam erişim",
      
      // Industries
      "industryTechnology": "Teknoloji",
      "industrySoftware": "Yazılım",
      "industryEcommerce": "E-Ticaret",
      "industryConstruction": "İnşaat",
      "industryManufacturing": "Üretim",
      "industryHealthcare": "Sağlık",
      "industryEducation": "Eğitim",
      "industryFinance": "Finans",
      "industryConsulting": "Danışmanlık",
      "industryMedia": "Medya",
      "industryTourism": "Turizm",
      "industryLogistics": "Lojistik",
      "industryRetail": "Perakende",
      "industryOther": "Diğer",
      
      // Header
      "search": "Ara...",
      "searchPlaceholder": "Proje, görev veya döküman ara... (Ctrl+K)",
      "notifications": "Bildirimler",
      "settings": "Ayarlar",
      "logout": "Çıkış Yap",
      
      // Search
      "searchResults": "Arama Sonuçları",
      "noResults": "Sonuç bulunamadı",
      "searchIn": "Arama yeri",
      "all": "Tümü",
      "projects": "Projeler",
      "tasks": "Görevler",
      "documents": "Dökümanlar",
      
      // Filters
      "filters": "Filtreler",
      "advancedFilters": "Gelişmiş Filtreler",
      "savedFilters": "Kaydedilmiş Filtreler",
      "saveFilter": "Filtreyi Kaydet",
      "clearFilters": "Filtreleri Temizle",
      "applyFilters": "Filtreleri Uygula",
      "filterName": "Filtre Adı",
      "dateRange": "Tarih Aralığı",
      "from": "Başlangıç",
      "to": "Bitiş",
      "status": "Durum",
      "priority": "Öncelik",
      "assignedTo": "Atanan Kişi",
      "tags": "Etiketler",
      
      // Status
      "status.todo": "Yapılacak",
      "status.in-progress": "Devam Ediyor",
      "status.done": "Tamamlandı",
      "todo": "Yapılacak",
      "inProgress": "Devam Ediyor",
      "done": "Tamamlandı",
      
      // Priority
      "priority.low": "Düşük",
      "priority.medium": "Orta",
      
      // Task Detail
      "assignedPerson": "Atanan Kişi",
      "timeSpent": "Harcanan Zaman",
      "checklist": "Kontrol Listesi",
      "checklistItems": "{{count}} madde",
      "estimatedDates": "Tahmini Tarihler",
      "actualDates": "Gerçekleşen Tarihler",
      "estimatedStart": "Tahmini Başlangıç",
      "estimatedEnd": "Tahmini Bitiş",
      "actualStart": "Gerçekleşen Başlangıç",
      "actualEnd": "Gerçekleşen Bitiş",
      "notSet": "Belirlenmemiş",
      "dateAndTime": "Tarih ve Saat",
      "priority.high": "Yüksek",
      "low": "Düşük",
      "medium": "Orta",
      "high": "Yüksek",
      
      // Common
      "cancel": "İptal",
      "save": "Kaydet",
      "delete": "Sil",
      "edit": "Düzenle",
      "close": "Kapat",
      "apply": "Uygula",
      "create": "Oluştur",
      "update": "Güncelle",
      "search": "Ara",
      
      // Dashboard
      "dashboard": "Ana Sayfa",
      "myProjects": "Projelerim",
      "myTasks": "Görevlerim",
      "reports": "Raporlar",
      "timesheets": "Çalışma Saatleri",
      "templates": "Şablonlar",
      "userManagement": "Kullanıcı Yönetimi",
      "supervisorPanel": "Yönetici Paneli",
      
      // Mobile
      "menu": "Menü",
      "openMenu": "Menüyü Aç",
      "closeMenu": "Menüyü Kapat",
      
      // Project Detail
      "projectDetail": "Proje Detayı",
      "newTask": "Yeni Görev",
      "createTask": "Görev Oluştur",
      "taskTitle": "Görev Başlığı",
      "taskDescription": "Açıklama",
      "selectAssignee": "Atanan Kişi Seç",
      "selectPriority": "Öncelik Seç",
      "selectStatus": "Durum Seç",
      "estimatedDates": "Tahmini Tarihler",
      "startDate": "Başlangıç Tarihi",
      "endDate": "Bitiş Tarihi",
      "duration": "Süre",
      "days": "Gün",
      "hours": "Saat",
      
      // View Modes
      "kanban": "Kanban",
      "list": "Liste",
      "calendar": "Takvim",
      "timeline": "Zaman Çizelgesi",
      "gantt": "Gantt",
      
      // Task Card
      "assignedTo": "Atanan",
      "dueDate": "Bitiş Tarihi",
      "comments": "Yorumlar",
      "attachments": "Ekler",
      
      // Dashboard Stats
      "companyTotalProjects": "Firmanın Toplam Projesi",
      "companyProjectsDesc": "Şirket genelindeki tüm projeler",
      "userCreatedProjects": "Oluşturduğunuz Projeler",
      "projectsYouCreated": "Sizin başlattığınız projeler",
      "userCreatedTasks": "Oluşturduğunuz Görevler",
      "tasksYouCreated": "Sizin oluşturduğunuz görevler",
      "userAssignedTasks": "Size Atanan Görevler",
      "tasksAssignedToYou": "Üzerinizde olan görevler",
      "notStarted": "Başlanmamış",
      "todoTasks": "Henüz başlanmayan görevler",
      "ongoingTasks": "Devam eden görevler",
      "completed": "Tamamlanan",
      "finishedTasks": "Bitirilen görevler",
      "taskStatus": "Görev Durumu",
      "allTasks": "Sistemdeki tüm görevler",
      "projectProgress": "Proje İlerlemesi",
      "recentProjects": "Son projelerinizin tamamlanma oranları",
      
      // Legacy (for backward compatibility)
      "totalProjects": "Toplam Proje",
      "totalTasks": "Toplam Görev",
      "assignedToYou": "Size Atanan Görevler",
      "createdByYou": "Oluşturduğunuz Görevler",
      "yourProjects": "Üye olduğunuz proje sayısı",
      "activeTasks": "Sizin aktif görevler",
      "tasksCreatedByYou": "Sizin oluşturduğunuz görevler",
      
      // Projects
      "newProject": "Yeni Proje",
      "createProject": "Proje Oluştur",
      "projectName": "Proje Adı",
      "projectDescription": "Açıklama",
      "noProjects": "Henüz proje yok",
      "createdAt": "Oluşturulma",
      
      // SMTP Settings
      "smtpSettings": "SMTP Ayarları",
      "emailServerConfig": "E-posta sunucu yapılandırması",
      "emailServerSettings": "E-posta Sunucu Ayarları",
      "configureSMTP": "Firmanıza özel SMTP ayarlarını yapılandırın. Bildirim e-postaları bu ayarlara göre gönderilecektir.",
      "smtpServer": "SMTP Sunucu",
      "smtpPort": "SMTP Port",
      "username": "Kullanıcı Adı",
      "usernameEmail": "Kullanıcı Adı (Email)",
      "senderEmail": "Gönderici Email",
      "senderName": "Gönderici Adı",
      "useSTARTTLS": "STARTTLS Kullan",
      "useSSLTLS": "SSL/TLS Kullan",
      "recommendedPort587": "Port 587 için önerilir",
      "recommendedPort465": "Port 465 için önerilir",
      "exampleServers": "Örn: smtp.gmail.com, smtp.yandex.com",
      "ifEmptyUsername": "Boş bırakırsanız kullanıcı adı kullanılır",
      "nameInEmails": "E-postalarda görünecek isim",
      "companyName": "Şirket Adı",
      "gmailImportantNote": "Gmail için Önemli Not",
      "gmailAppPassword": "Gmail kullanıyorsanız, Google hesabınızdan \"App Password\" (Uygulama Şifresi) oluşturmanız gerekir. Normal Gmail şifreniz çalışmayacaktır.",
      "useAppPasswordGmail": "Gmail için App Password kullanın",
      "testConnection": "Bağlantıyı Test Et",
      "saveSettings": "Ayarları Kaydet",
      "smtpSaved": "SMTP ayarları kaydedildi",
      "smtpSaveFailed": "SMTP ayarları kaydedilemedi",
      "connectionSuccess": "Bağlantı başarılı!",
      "connectionFailed": "Bağlantı başarısız",
      
      // ProjectDetail & Tasks
      "notProjectMember": "Projeye üyeliğiniz bulunmamaktadır",
      "projectLoadFailed": "Proje yüklenemedi",
      "tasksLoadFailed": "Görevler yüklenemedi",
      "usersLoadFailed": "Kullanıcılar yüklenemedi",
      "commentsLoadFailed": "Yorumlar yüklenemedi",
      "taskCreated": "Görev oluşturuldu!",
      "statusUpdated": "Durum güncellendi",
      "statusUpdateFailed": "Durum güncellenemedi",
      "confirmDeleteTask": "Bu görevi silmek istediğinizden emin misiniz?",
      "taskDeleted": "Görev silindi",
      
      // Templates
      "templatesLoadFailed": "Şablonlar yüklenemedi",
      "templateNameRequired": "Şablon adı ve görev başlığı zorunludur",
      "templateUpdated": "Şablon güncellendi",
      "templateCreated": "Şablon oluşturuldu",
      "templateUpdateFailed": "Şablon güncellenemedi",
      "templateCreateFailed": "Şablon oluşturulamadı",
      "confirmDeleteTemplate": "Bu şablonu silmek istediğinizden emin misiniz?",
      "templateDeleted": "Şablon silindi",
      "templateDeleteFailed": "Şablon silinemedi",
      "editTemplate": "Şablonu Düzenle",
      "createNewTemplate": "Yeni Şablon Oluştur",
      
      // Supervisor Panel
      "dataLoadFailed": "Veriler yüklenemedi",
      "companyCreated": "Firma oluşturuldu!",
      "companyCreateFailed": "Firma oluşturulamadı",
      "adminCreated": "Admin kullanıcısı oluşturuldu!",
      "adminCreateFailed": "Admin oluşturulamadı",
      "companyActivated": "Firma aktif edildi",
      "companyDeactivated": "Firma devre dışı bırakıldı",
      "operationFailed": "İşlem başarısız",
      "companyUpdated": "Firma güncellendi!",
      "companyUpdateFailed": "Firma güncellenemedi",
      "updatedAt": "Güncellenme",
      "employer": "İşveren",
      "upperEmployer": "Üst İşveren",
      "mainContractor": "Ana Yüklenici",
      "optional": "Opsiyonel",
      "employerPlaceholder": "İşveren adı",
      "upperEmployerPlaceholder": "Üst işveren adı (varsa)",
      "mainContractorPlaceholder": "Ana yüklenici adı (varsa)",
      "editProject": "Projeyi Düzenle",
      "editProjectDescription": "Proje bilgilerini güncelleyin",
      "deleteProject": "Projeyi Sil",
      "deleteProjectTitle": "Projeyi Kalıcı Olarak Sil",
      "deleteProjectWarning": "Bu işlem geri alınamaz! Proje ve ona bağlı TÜM veriler kalıcı olarak silinecektir.",
      "deleteProjectImpact": "Silinecek veriler:",
      "allTasksWillBeDeleted": "Tüm görevler",
      "allSubtasksWillBeDeleted": "Tüm alt görevler",
      "allCommentsWillBeDeleted": "Tüm yorumlar",
      "allTimeLogsWillBeDeleted": "Tüm zaman kayıtları",
      "allNotificationsWillBeDeleted": "Tüm bildirimler",
      "allDocumentsWillBeDeleted": "Tüm dökümanlar",
      "typeProjectNameToConfirm": "Onaylamak için proje adını yazın",
      "deleteProjectPermanently": "Projeyi Kalıcı Olarak Sil",
      "saveChanges": "Değişiklikleri Kaydet",
      
      // Settings
      "accountSettings": "Hesap Ayarları",
      "changePassword": "Şifre Değiştir",
      "currentPassword": "Mevcut Şifre",
      "newPassword": "Yeni Şifre",
      "confirmPassword": "Şifre Tekrar",
      "updatePassword": "Şifreyi Güncelle",
      "emailNotifications": "E-posta Bildirimleri",
      "taskAssigned": "Görev Atandı",
      "taskCommented": "Görev Yorumlandı",
      "taskStatusChanged": "Görev Durumu Değişti",
      "memberAdded": "Üye Eklendi",
      "profilePicture": "Profil Fotoğrafı",
      "profilePictureDescription": "Yüz fotoğrafınızı yükleyin (JPG veya PNG, maksimum 5MB)",
      "profilePictureHint": "JPG veya PNG formatında, maksimum 5MB",
      "uploadPicture": "Fotoğrafı Yükle",
      "deletePicture": "Fotoğrafı Sil",
      "uploading": "Yükleniyor...",
      "profilePictureUploaded": "Profil fotoğrafı yüklendi",
      "profilePictureDeleted": "Profil fotoğrafı silindi",
      "invalidFileType": "Geçersiz dosya formatı. Sadece resim dosyaları desteklenir",
      "fileTooLarge": "Dosya çok büyük. Maksimum 5MB",
      "selectFile": "Lütfen bir dosya seçin",
      "uploadFailed": "Yükleme başarısız",
      "deleteFailed": "Silme başarısız",
      "members": "üye",
      "searchProjects": "Projelerde ara...",
      "filterProjects": "Filtrele",
      "allProjects": "Tüm Projeler",
      "myProjects": "Sahip Olduklarım",
      "memberProjects": "Üye Olduklarım",
      "noProjectsFound": "Proje bulunamadı",
      "tryDifferentSearch": "Farklı bir arama veya filtre deneyin",
      "created": "Oluşturuldu",
      "estimatedStart": "Tahmini Başlangıç",
      "actualStart": "Gerçekleşen Başlangıç",
      
      // Resources
      "resourceManagement": "Kaynak Yönetimi",
      "resources": "Kaynaklar",
      "addResource": "Kaynak Ekle",
      "editResource": "Kaynağı Düzenle",
      "deleteResource": "Kaynağı Sil",
      "resourceType": "Kaynak Türü",
      "resourceFormDescription": "Kaynak bilgilerini girin",
      "searchResources": "Kaynaklarda ara...",
      "noResourcesFound": "Kaynak bulunamadı",
      "addFirstResource": "İlk Kaynağı Ekle",
      "resourceCreated": "Kaynak oluşturuldu",
      "resourceUpdated": "Kaynak güncellendi",
      "resourceDeleted": "Kaynak silindi",
      "resourcesLoadFailed": "Kaynaklar yüklenemedi",
      "confirmDeleteResource": "Bu kaynağı silmek istediğinizden emin misiniz?",
      "human": "İnsan Kaynağı",
      "equipment": "Ekipman",
      "material": "Malzeme",
      "financial": "Finansal",
      "time": "Zaman",
      "knowledge": "Bilgi",
      "digital": "Dijital",
      "available": "Müsait",
      "in_use": "Kullanımda",
      "maintenance": "Bakımda",
      "unavailable": "Müsait Değil",
      "role": "Rol",
      "hourlyRate": "Saatlik Ücret",
      "capacity": "Kapasite",
      "hoursPerWeek": "Saat/Hafta",
      "serialNumber": "Seri Numarası",
      "costPerUse": "Kullanım Başına Maliyet",
      "location": "Konum",
      "stockQuantity": "Stok Miktarı",
      "unit": "Birim",
      "unitPrice": "Birim Fiyat",
      "unitPlaceholder": "ör. adet, kg, m",
      "totalBudget": "Toplam Bütçe",
      "costCenter": "Maliyet Merkezi",
      
      // User Management
      "addUser": "Kullanıcı Ekle",
      "userName": "İsim",
      "userEmail": "E-posta",
      "userRole": "Rol",
      "actions": "İşlemler",
      "selectRole": "Rol Seç",
      "manager": "Müdür",
      "engineer": "Mühendis",
      "personnel": "Personel",
      "member": "Personel",  // Backward compatibility
      
      // Login
      "login": "Giriş Yap",
      "email": "E-posta",
      "password": "Şifre",
      "welcomeBack": "Tekrar Hoş Geldiniz",
      "loginToAccount": "Hesabınıza giriş yapın",
      "loading": "Lütfen bekleyin",
      
      // Settings
      "profileSettings": "Profil Ayarları",
      "passwordSettings": "Şifre Ayarları",
      "notificationSettings": "Bildirim Ayarları",
      "fullName": "Ad Soyad",
      "emailAddress": "E-posta Adresi",
      "saveChanges": "Değişiklikleri Kaydet",
      "taskAssignedNotif": "Görev atandığında bildir",
      "commentNotif": "Görev yorumlandığında bildir",
      "statusChangedNotif": "Görev durumu değiştiğinde bildir",
      "memberAddedNotif": "Üye eklendiğinde bildir",
      "passwordMismatch": "Şifreler eşleşmiyor",
      "passwordMinLength": "Şifre en az 6 karakter olmalı",
      "passwordChanged": "Şifre başarıyla değiştirildi",
      "savingChanges": "Kaydediliyor...",
      "changingPassword": "Değiştiriliyor...",
      
      // Reports
      "reportsDashboard": "Raporlar",
      "selectReport": "Rapor Seç",
      "burndownChart": "Burndown Chart",
      "memberPerformance": "Üye Performansı",
      "timeTracking": "Zaman Takibi",
      "exportExcel": "Excel'e Aktar",
      "selectProject": "Proje Seç",
      "allProjects": "Tüm Projeler",
      "generateReport": "Rapor Oluştur",
      
      // Templates
      "taskTemplates": "Görev Şablonları",
      "createTemplate": "Şablon Oluştur",
      "templateName": "Şablon Adı",
      "templateDescription": "Şablon Açıklaması",
      "addTask": "Görev Ekle",
      "noTemplates": "Henüz şablon yok",
      "useTemplate": "Şablonu Kullan",
      
      // User Management
      "userManagement": "Kullanıcı Yönetimi",
      "addNewUser": "Yeni Kullanıcı Ekle",
      "editUser": "Kullanıcı Düzenle",
      "deleteUser": "Kullanıcı Sil",
      "confirmDelete": "Silmek istediğinize emin misiniz?",
      "userAdded": "Kullanıcı eklendi",
      "userUpdated": "Kullanıcı güncellendi",
      "userDeleted": "Kullanıcı silindi",
      
      // SMTP Settings
      "smtpSettings": "SMTP Ayarları",
      "smtpHost": "SMTP Sunucu",
      "smtpPort": "SMTP Port",
      "smtpUser": "SMTP Kullanıcı",
      "smtpPassword": "SMTP Şifre",
      "useSSL": "SSL Kullan",
      "testConnection": "Bağlantıyı Test Et",
      "smtpSaved": "SMTP ayarları kaydedildi",
      
      // Supervisor Panel
      "supervisorPanel": "Yönetici Paneli",
      "companyManagement": "Firma Yönetimi",
      "totalCompanies": "Toplam Firma",
      "activeCompanies": "Aktif Firmalar",
      "totalUsers": "Toplam Kullanıcı",
      "companyName": "Firma Adı",
      "companyEmail": "Firma E-posta",
      "companyPhone": "Firma Telefon",
      "companyAddress": "Firma Adresi",
      "addCompany": "Firma Ekle",
      "editCompany": "Firma Düzenle",
      "deleteCompany": "Firma Sil",
      "companyActive": "Aktif",
      "companyPassive": "Pasif",
      "adminUser": "Yönetici Kullanıcı",
      "addAdmin": "Yönetici Ekle",
      
      // Billing & Subscription
      "billing": {
        "title": "Faturalama ve Abonelik",
        "currentPlan": "Mevcut Planınız",
        "currentPlanDesc": "Aktif abonelik bilgileriniz",
        "nextBilling": "Sonraki Fatura Tarihi",
        "autoRenew": "Otomatik Yenileme",
        "cancelSubscription": "Aboneliği İptal Et",
        "noSubscription": "Henüz aktif bir aboneliğiniz yok",
        "upgradePlan": "Plana Yükselt",
        "availablePlans": "Mevcut Planlar",
        "availablePlansDesc": "Size uygun planı seçin",
        "free": "Ücretsiz",
        "month": "Ay",
        "year": "Yıl",
        "selectPlan": "Planı Seç",
        "contactSales": "Satış ile İletişime Geç",
        "paymentHistory": "Ödeme Geçmişi",
        "paymentHistoryDesc": "Geçmiş ödemeleriniz",
        "noPayments": "Henüz ödeme bulunmuyor",
        "payment": "Ödeme",
        "completePayment": "Ödemeyi Tamamla",
        "creditCard": "Kredi Kartı",
        "bankTransfer": "Havale / EFT",
        "cardHolder": "Kart Sahibi",
        "cardHolderPlaceholder": "Ad Soyad",
        "cardNumber": "Kart Numarası",
        "expiryMonth": "Ay",
        "expiryYear": "Yıl",
        "testCards": "Test Kartları",
        "success": "Başarılı",
        "failed": "Başarısız",
        "bankTransferInfo": "Havale/EFT Bilgileri",
        "yourBankName": "Bankanızın Adı",
        "bankNamePlaceholder": "örn. Garanti BBVA",
        "yourIban": "IBAN Numaranız",
        "referenceNumber": "Referans Numarası",
        "referencePlaceholder": "Ödeme referansınız",
        "bankTransferNote": "Havale işleminiz sonrası sistem yöneticimiz tarafından manuel olarak onaylanacaktır. Bu işlem 1-2 iş günü sürebilir.",
        "processing": "İşleniyor...",
        "payNow": "Şimdi Öde",
        "submitTransfer": "Havale Bilgilerini Gönder",
        "fillAllFields": "Lütfen tüm alanları doldurun",
        "paymentSuccess": "Ödeme başarılı!",
        "paymentFailed": "Ödeme başarısız oldu",
        "bankTransferCreated": "Havale kaydınız oluşturuldu. Onay sonrası aboneliğiniz aktif hale gelecektir.",
        "paymentError": "Ödeme işlenirken bir hata oluştu",
        "confirmCancel": "Aboneliğinizi iptal etmek istediğinizden emin misiniz?",
        "subscriptionCancelled": "Abonelik iptal edildi",
        "cancelError": "İptal işlemi başarısız oldu",
        "autoRenewUpdated": "Otomatik yenileme ayarı güncellendi",
        "autoRenewError": "Ayar güncellenirken hata oluştu",
        "noCompany": "Firma bilgisi bulunamadı",
        "fetchError": "Bilgiler yüklenirken hata oluştu",
        "bankLabel": "Banka",
        "ibanLabel": "IBAN",
        "receiverLabel": "Alıcı",
        "bankValue": "Garanti BBVA",
        "ibanValue": "TR33 0062 1000 0000 0006 2956 35",
        "receiverValue": "Ener Yazılım Elektronik Bilişim Güvenlik Teknolojileri San. Tic. Ltd. Şti.",
        "statusActive": "Aktif",
        "statusPending": "Beklemede",
        "statusCancelled": "İptal Edildi",
        "statusSuccess": "Başarılı",
        "statusFailed": "Başarısız"
      },
      
      // Upgrade Modal
      "upgrade": {
        "userLimitReached": "Kullanıcı Limiti Doldu!",
        "projectLimitReached": "Proje Limiti Doldu!",
        "limitReached": "Limit Doldu!",
        "userLimitDescription": "Mevcut planınızda maksimum {{limit}} kullanıcı ekleyebilirsiniz. Şu anda {{current}} kullanıcınız var.",
        "projectLimitDescription": "Mevcut planınızda maksimum {{limit}} proje oluşturabilirsiniz. Şu anda {{current}} projeniz var.",
        "limitDescription": "Plan limitinize ulaştınız",
        "currentPlan": "Mevcut Planınız",
        "currentUsage": "Kullanım",
        "professionalBenefits": "Profesyonel Plan Avantajları",
        "unlimitedUsers": "Sınırsız kullanıcı",
        "unlimitedProjects": "Sınırsız proje",
        "allViewModes": "Tüm görünüm modları (Kanban, Gantt, vb.)",
        "advancedReporting": "Gelişmiş raporlama ve analitik",
        "activityLog": "Aktivite log ve izleme",
        "prioritySupport": "7/24 öncelikli destek",
        "freeLimitations": "Ücretsiz Plan Kısıtlamaları",
        "maxUsers": "Maksimum {{count}} kullanıcı",
        "maxProjects": "Maksimum {{count}} proje",
        "limitedFeatures": "Kısıtlı özellikler",
        "professionalPlan": "Profesyonel Plan",
        "upgradeNow": "Şimdi Yükselt",
        "maybeLater": "Belki Sonra",
        "viewPlans": "Planları Görüntüle"
      },
      
      // Upgrade Modal
      "upgrade": {
        "userLimitReached": "User Limit Reached!",
        "projectLimitReached": "Project Limit Reached!",
        "limitReached": "Limit Reached!",
        "userLimitDescription": "You can add maximum {{limit}} users in your current plan. You currently have {{current}} users.",
        "projectLimitDescription": "You can create maximum {{limit}} projects in your current plan. You currently have {{current}} projects.",
        "limitDescription": "You've reached your plan limit",
        "currentPlan": "Current Plan",
        "currentUsage": "Usage",
        "professionalBenefits": "Professional Plan Benefits",
        "unlimitedUsers": "Unlimited users",
        "unlimitedProjects": "Unlimited projects",
        "allViewModes": "All view modes (Kanban, Gantt, etc.)",
        "advancedReporting": "Advanced reporting and analytics",
        "activityLog": "Activity logging and tracking",
        "prioritySupport": "24/7 priority support",
        "freeLimitations": "Free Plan Limitations",
        "maxUsers": "Maximum {{count}} users",
        "maxProjects": "Maximum {{count}} projects",
        "limitedFeatures": "Limited features",
        "professionalPlan": "Professional Plan",
        "upgradeNow": "Upgrade Now",
        "maybeLater": "Maybe Later",
        "viewPlans": "View Plans"
      },
      
      // Common Actions
      "description": "Açıklama",
      "active": "Aktif",
      "inactive": "Pasif",
      "yes": "Evet",
      "no": "Hayır",
      "confirm": "Onayla",
      "success": "Başarılı",
      "error": "Hata",
      
      // Task Dependencies
      "taskDependencies": "Görev Bağımlılıkları",
      "complete": "Tamamlandı",
      "taskBlocked": "Bu görev diğer görevlere bağımlı",
      "waitingForTasks": "{{count}} görevin tamamlanması bekleniyor",
      "taskImpact": "Bu görev {{count}} görevi etkiliyor",
      "graphView": "Grafik Görünümü",
      "listView": "Liste Görünümü",
      "thisTaskDependsOn": "Bu görev şunlara bağlı",
      "thisTaskBlocking": "Bu görev şunları bloke ediyor",
      "addDependency": "Bağımlılık Ekle",
      "selectTask": "Görev seçin",
      "noAvailableTasks": "Eklenebilecek görev yok",
      "add": "Ekle",
      "dependencyHelpText": "Bu görev, seçilen göreve bağımlı olacak ve o tamamlanmadan 'Devam Ediyor' durumuna geçemeyecek.",
      "noDependenciesYet": "Henüz bağımlılık yok",
      "noDependenciesDescription": "Görevler arasında bağımlılık oluşturarak iş akışınızı düzenleyin",
      "pleaseSelectTask": "Lütfen bir görev seçin",
      "dependencyAdded": "Bağımlılık eklendi",
      "dependencyAddFailed": "Bağımlılık eklenemedi",
      "dependencyRemoved": "Bağımlılık kaldırıldı",
      "dependencyRemoveFailed": "Bağımlılık kaldırılamadı",
      "noDependencies": "Henüz bağımlılık yok",
      "currentTask": "Mevcut Görev",
      "blockedBy": "Bağımlı",
      "blocking": "Engelliyor",
      "thisTask": "Bu Görev",
      "dependsOnConnection": "Bağımlılık bağlantısı",
      "blockingConnection": "Engelleme bağlantısı",
      
      // Access Control
      "accessDenied": "Erişim Reddedildi",
      "noPermission": "Bu sayfaya erişim yetkiniz yok",
      
      // User Management Additional
      "usersLoadFailed": "Kullanıcılar yüklenemedi",
      "userCreated": "Kullanıcı oluşturuldu!",
      "userCreateFailed": "Kullanıcı oluşturulamadı",
      "userUpdated": "Kullanıcı güncellendi!",
      "userUpdateFailed": "Kullanıcı güncellenemedi",
      "userDeleted": "Kullanıcı silindi!",
      "userDeleteFailed": "Kullanıcı silinemedi",
      "enterName": "İsim girin",
      "strongPassword": "Güçlü bir şifre",
      "createNewUser": "Yeni Kullanıcı Oluştur",
      "createUserForCompany": "Firmanız için yeni bir kullanıcı oluşturun",
      "fullName": "Ad Soyad",
      "password": "Şifre",
      "role": "Rol",
      "createUser": "Kullanıcı Oluştur",
      "editUserTitle": "Kullanıcı Düzenle",
      "updateUser": "Kullanıcı Güncelle",
      "roleDescriptions": "Müdür: Proje yönetimi, Mühendis: Görev yönetimi, Personel: Görev takibi",
      "totalUsers": "Toplam Kullanıcı",
      "engineer": "Mühendis",
      "personnel": "Personel",
      "users": "Kullanıcılar",
      "allCompanyUsers": "Firmadaki tüm kullanıcılar",
      "newUser": "Yeni Kullanıcı",
      "adminCannotEdit": "Admin düzenlenemez",
      "createdAt": "Oluşturulma",
      
      // Projects
      "projectsLoadFailed": "Projeler yüklenemedi",
      "projectCreated": "Proje oluşturuldu!",
      "projectCreateFailed": "Proje oluşturulamadı",
      "projectUpdated": "Proje güncellendi!",
      "projectUpdateFailed": "Proje güncellenemedi",
      "noUpdatePermission": "Bu projeyi güncelleme yetkiniz yok",
      "projectNameMismatch": "Proje adı eşleşmiyor",
      "projectDeleted": "Proje ve tüm ilgili veriler silindi",
      "noDescription": "Açıklama yok",
      
      // Sprint & Resources
      "sprintManagement": "Sprint Yönetimi",
      "resourceSearch": "Kaynak Arama",
      "manageProjectSprints": "Proje sprint'lerinizi yönetin",
      "findResourcesBySkills": "Yeteneklere ve müsaitliğe göre kaynak bulun",
      "newSprint": "Yeni Sprint",
      "editSprint": "Sprint Düzenle",
      "sprintName": "Sprint Adı",
      "sprintGoal": "Sprint Hedefi",
      "writeSprintGoal": "Sprint hedefini yazın...",
      "sprintStatus": "Sprint Durumu",
      "planned": "Planlandı",
      "active": "Aktif",
      "completed": "Tamamlandı",
      "cancelled": "İptal Edildi",
      "sprintCreated": "Sprint oluşturuldu",
      "sprintUpdated": "Sprint güncellendi",
      "sprintDeleted": "Sprint silindi",
      "sprintStarted": "Sprint başlatıldı",
      "confirmDeleteSprint": "Bu sprint'i silmek istediğinizden emin misiniz?",
      "taskCount": "Görev Sayısı",
      "selectProject": "Proje Seçin",
      "noSprintsYet": "Henüz sprint yok",
      "createFirstSprint": "İlk sprint'inizi oluşturun",
      "sprintsLoadFailed": "Sprint'ler yüklenemedi",
      "fillRequiredFields": "Lütfen tüm zorunlu alanları doldurun (* ile işaretli)",
      "endDateAfterStart": "Bitiş tarihi başlangıç tarihinden sonra olmalıdır",
      "sprintStartedEmailSent": "Sprint başlatıldı! E-postalar gönderildi.",
      "sprintStatusUpdated": "Sprint durumu güncellendi",
      "statusUpdateFailed": "Durum güncellenemedi",
      "sprintDeleteFailed": "Sprint silinemedi",
      
      // Resource Search
      "resourceType": "Kaynak Tipi",
      "skill": "Yetenek",
      "minLevel": "Min Seviye",
      "availableFrom": "Müsait Başlangıç",
      "availableTo": "Müsait Bitiş",
      "searchResourceName": "Kaynak ismi...",
      "searchResults": "Arama Sonuçları",
      "noResourcesFound": "Kaynak bulunamadı",
      "skills": "Yetenekler",
      "availability": "Müsaitlik",
      
      // ProjectDetail Additional
      "taskTitleRequired": "Lütfen görev başlığı girin (* ile işaretli alan zorunludur)",
      "taskCreationFailed": "Görev oluşturulamadı",
      "commentAdded": "Yorum eklendi",
      "commentAddFailed": "Yorum eklenemedi",
      "confirmDeleteTaskMsg": "Bu görevi silmek istediğinizden emin misiniz?",
      "cannotDeleteOnlyCreator": "Bu görevi silme yetkiniz yok. Sadece oluşturan kişi silebilir.",
      "taskDeleteFailed": "Görev silinemedi",
      "timeSaved": "Zaman kaydedildi",
      "timeSaveFailed": "Zaman kaydedilemedi",
      "startedAt": "Başlangıç",
      "finishedAt": "Bitiş",
      "noTimeRecordedYet": "Henüz zaman kaydı yok",
      "changeStatus": "Durum Değiştir",
      "addTime": "Zaman Ekle",
      "send": "Gönder",
      "deleteTask": "Görevi Sil",
      "fromTemplate": "Şablondan",
      "manageResources": "Kaynakları Yönet",
      "projectResources": "Proje Kaynakları",
      "resourceManagementInfo": "ℹ️ Detaylı kaynak yönetimi, rezervasyon ve atama için 'Kaynakları Yönet' butonuna tıklayın.",
      "enterTaskDetails": "Görev detaylarını girin",
      "selectUserOptional": "Kullanıcı seçin (opsiyonel)",
      "unassigned": "Atanmamış",
      "selectSprintOptional": "Sprint seçin (opsiyonel)",
      "noSprint": "Sprint Yok",
      "selectDate": "Tarih seçin",
      "ganttPlanningOptional": "Gantt Planlama (Opsiyonel)",
      "hide": "Gizle",
      "show": "Göster",
      "estimatedStartDate": "Tahmini Başlangıç Tarihi",
      "defaultCreationDate": "Varsayılan: Oluşturma Tarihi",
      "estimatedDurationDays": "Tahmini Süre (Gün)",
      "estimatedDurationHours": "Tahmini Süre (Saat)",
      "estimatedEndDate": "Tahmini Bitiş Tarihi",
      "durationOrManual": "Süre veya manuel seçin",
      "durationAutoCalculateHint": "💡 Süre girerseniz otomatik hesaplanır. Hem süre hem bitiş tarihi girerseniz en geç olan kullanılır.",
      "startTask": "Göreve Başla",
      "completeTask": "Görevi Tamamla",
      "taskStarted": "Göreve başlandı!",
      "taskStartFailed": "Başlatma başarısız",
      "taskCompleted": "Görev tamamlandı!",
      "taskCompleteFailed": "Tamamlama başarısız",
      "addComment": "Yorum ekle...",
      "minutesShort": "dk",
      "hoursShort": "s",
      "membersTab": "Üyeler",
      "documentsTab": "Dökümanlar",
      
      // Templates Additional
      "backToDashboard": "Dashboard'a Dön",
      "taskTemplates": "Görev Şablonları",
      "saveTemplatesDesc": "Sık kullandığınız görev yapılarını şablon olarak kaydedin",
      "newTemplate": "Yeni Şablon",
      "editTemplateTitle": "Şablonu Düzenle",
      "createNewTemplateTitle": "Yeni Şablon Oluştur",
      "templateFormDesc": "Şablon bilgilerini doldurun. Bu şablondan hızlıca görev oluşturabilirsiniz.",
      "templateNameLabel": "Şablon Adı *",
      "templateNamePlaceholder": "örn: Sprint Planlama Görevi",
      "templateDescLabel": "Şablon Açıklaması",
      "templateDescPlaceholder": "Bu şablon ne için kullanılıyor?",
      "taskTitleLabel": "Görev Başlığı *",
      "taskTitlePlaceholder": "Oluşturulacak görevin başlığı",
      "taskDescLabel": "Görev Açıklaması",
      "taskDescPlaceholder": "Oluşturulacak görevin açıklaması",
      "priorityLabel": "Öncelik",
      "tagsLabel": "Etiketler",
      "tagsPlaceholder": "sprint, planlama, toplantı",
      "separateWithCommas": "Virgülle ayırın",
      "saving": "Kaydediliyor...",
      "updating": "Güncelle",
      "creating": "Oluştur",
      "loading": "Yükleniyor...",
      "noTemplatesYet": "Henüz şablon yok",
      "createFirstTemplate": "İlk şablonunuzu oluşturarak sık kullandığınız görev yapılarını kaydedin",
      "taskTitleColon": "Görev Başlığı:",
      "descriptionColon": "Açıklama:",
      
      // SupervisorPanel Additional
      "noAccessToPage": "Bu sayfaya erişim yetkiniz yok",
      "companyCreationFailed": "Firma oluşturulamadı",
      "adminCreationFailed": "Admin oluşturulamadı",
      "companyDeactivated": "Firma devre dışı bırakıldı",
      "companyActivated": "Firma aktif edildi",
      "operationFailed": "İşlem başarısız",
      "usersLoadFailed": "Kullanıcılar yüklenemedi",
      "confirmDeleteCompany": "{{companyName}} firmasını ve tüm verilerini silmek istediğinizden emin misiniz? Bu işlem geri alınamaz!",
      "companyDeletedSummary": "Firma silindi! {{users}} kullanıcı, {{projects}} proje, {{tasks}} görev silindi.",
      "companyDeleteFailed": "Firma silinemedi",
      "confirmDeleteUser": "{{userName}} kullanıcısını silmek istediğinizden emin misiniz?",
      "cannotDeleteUser": "Kullanıcı silinemez",
      "adminRole": "Admin",
      "managerRole": "Müdür",
      "engineerRole": "Mühendis",
      "personnelRole": "Personel",
      "supervisorPanel": "Süpervizör Paneli",
      "companySystemManagement": "Firma ve sistem yönetimi",
      "logout": "Çıkış Yap",
      "totalCompanies": "Toplam Firma",
      "activeCompany": "Aktif Firma",
      "totalUsers": "Toplam Kullanıcı",
      "totalProjects": "Toplam Proje",
      "totalTasks": "Toplam Görev",
      "companiesTitle": "Firmalar",
      "allSystemCompanies": "Sistemdeki tüm firmalar",
      "newCompany": "Yeni Firma",
      "noCompaniesYet": "Henüz firma eklenmemiş",
      "activeStatus": "Aktif",
      "passiveStatus": "Pasif",
      "adminUsers": "Admin Kullanıcılar",
      "usersButton": "Kullanıcılar",
      "adminButton": "Admin",
      "editButton": "Düzenle",
      "passiveButton": "Pasif",
      "activeButton": "Aktif",
      "createNewCompany": "Yeni Firma Oluştur",
      "addNewCompanyToSystem": "Sisteme yeni bir firma ekleyin",
      "companyNameLabel": "Firma Adı *",
      "companyNamePlaceholder": "Örnek Yazılım Ltd.",
      "emailLabel": "Email *",
      "emailPlaceholder": "info@ornek.com",
      "phoneLabel": "Telefon",
      "phonePlaceholder": "+90 555 123 4567",
      "addressLabel": "Adres",
      "addressPlaceholder": "İstanbul, Türkiye",
      "createCompanyButton": "Firma Oluştur",
      "editCompanyTitle": "Firma Düzenle",
      "updateCompanyInfo": "Firma bilgilerini güncelleyin",
      "updateCompanyButton": "Firma Güncelle",
      "createCompanyAdmin": "Firma Admin'i Oluştur",
      "createAdminForCompany": "{{companyName}} için admin kullanıcısı oluşturun",
      "fullNameLabel": "Ad Soyad *",
      "fullNamePlaceholder": "Ahmet Yılmaz",
      "passwordLabel": "Şifre *",
      "strongPasswordPlaceholder": "Güçlü bir şifre",
      "createAdminButton": "Admin Kullanıcısı Oluştur",
      "companyUsers": "Firma Kullanıcıları",
      "companyUsersCount": "{{companyName}} - Toplam {{count}} kullanıcı",
      "noUsersInCompany": "Bu firmada henüz kullanıcı yok",
      "createdAtLabel": "Oluşturulma:",
      "editUserTitle": "Kullanıcı Düzenle",
      "updateUserInfo": "Kullanıcı bilgilerini güncelleyin",
      "roleLabel": "Rol *",
      "selectRoleLabel": "Rol seçin",
      "updateUserButton": "Kullanıcı Güncelle",
      "taskDetailsManagement": "Görev detayları ve yönetim seçenekleri",
      "templatesLoadFailed": "Şablonlar yüklenemedi",
      "templateNameTaskTitleRequired": "Şablon adı ve görev başlığı zorunludur",
      "confirmDeleteTemplate": "Bu şablonu silmek istediğinizden emin misiniz?",
      "dataLoadFailed": "Veriler yüklenemedi",
      "companyCreated": "Firma oluşturuldu!",
      "adminUserCreated": "Admin kullanıcısı oluşturuldu!",
      "companyUpdated": "Firma güncellendi!",
      "userUpdated": "Kullanıcı güncellendi!",
      "userDeleted": "Kullanıcı silindi!",
      "userUpdateFailed": "Kullanıcı güncellenemedi",
      
      // Landing Page Türkçe
      "landing": {
        "features": "Özellikler",
        "pricing": "Fiyatlandırma",
        "login": "Giriş",
        "start": "Başla",
        "startFree": "Ücretsiz Başla",
        "cloudBadge": "☁️ Cloud-Based SaaS Çözümü",
        "heroTitle": "Proje Yönetimini",
        "heroSubtitle": "Bulut'ta Yönetin",
        "heroDescription": "Kurulum gerektirmeyen, anında kullanıma hazır profesyonel proje yönetim sistemi. Ücretsiz başlayın, ihtiyacınıza göre büyütün.",
        "startFreeButton": "Ücretsiz Başlayın",
        "discoverFeatures": "Özellikleri Keşfet",
        
        // İstatistikler
        "activeUsers": "Aktif Kullanıcı",
        "completedProjects": "Tamamlanan Proje",
        "teamSatisfaction": "Ekip Memnuniyeti",
        "uptimeRate": "Çalışma Süresi",
        
        // Özellikler
        "featuresTitle": "Güçlü Özellikler",
        "featuresDescription": "Proje yönetimini kolaylaştıran ve ekip verimliliğini artıran özellikler",
        "multiUserManagement": "Çok Kullanıcılı Yönetim",
        "multiUserManagementDesc": "Supervisor, Admin, Manager, Engineer, Personnel rolleri ile kapsamlı yetkilendirme",
        "multipleViews": "Çoklu Görünüm",
        "multipleViewsDesc": "Kanban, Liste, Takvim, Zaman Çizelgesi, Gantt - Size uygun görünümü seçin",
        "taskManagement": "Görev Yönetimi",
        "taskManagementDesc": "Alt görevler, bağımlılıklar, tekrarlayan görevler, checklist desteği",
        "timesheetTracking": "Zaman Takibi",
        "timesheetTrackingDesc": "Her görev için detaylı zaman takibi ve raporlama",
        "reportingAnalytics": "Raporlama & Analiz",
        "reportingAnalyticsDesc": "Anlık raporlar ve performans analizi",
        "teamCollaboration": "Ekip İşbirliği",
        "teamCollaborationDesc": "Yorumlar, bildirimler, dosya paylaşımı",
        
        // Detaylı Özellikler
        "detailedFeaturesTitle": "Detaylı Özellikler",
        "detailedFeaturesDescription": "Milestora ile proje yönetiminizi bir üst seviyeye taşıyın",
        "projectTaskManagementTitle": "Proje & Görev Yönetimi",
        "projectTaskManagementDesc": "Kapsamlı görev yönetimi ile projelerinizi tam kontrol altında tutun. Alt görevler, bağımlılıklar, tekrarlayan görevler ve checklist desteği ile her detayı planlayın.",
        "roleBasedAccessTitle": "Rol Bazlı Erişim Kontrolü",
        "roleBasedAccessDesc": "5 farklı rol seviyesi (Supervisor, Admin, Manager, Engineer, Personnel) ile ekip üyelerinize uygun yetkilendirme yapın. Güvenli ve organize bir çalışma ortamı oluşturun.",
        "timesheetManagementTitle": "Zaman Çizelgesi Yönetimi",
        "timesheetManagementDesc": "Detaylı zaman takibi ile çalışma saatlerini kaydedin. Haftalık görünüm, iş tipi ayrımı (normal, fazla mesai, hafta sonu, tatil) ve onay süreci ile profesyonel timesheet yönetimi.",
        "reportingTitle": "Raporlama & Analitik",
        "reportingDesc": "Gerçek zamanlı raporlar ve analizler ile proje performansını takip edin. Excel export, grafikler ve detaylı istatistikler ile veriye dayalı kararlar alın.",
        "activityLogTitle": "Aktivite Loglama",
        "activityLogDesc": "Sistemdeki tüm işlemleri kaydedin ve takip edin. Kim, ne zaman, ne yaptı? Denetim ve güvenlik için kapsamlı aktivite loglama sistemi.",
        "notificationSystemTitle": "Bildirim Sistemi",
        "notificationSystemDesc": "E-posta bildirimleri ile görev atamaları, yorumlar, durum değişiklikleri hakkında anında haberdar olun. Kişiselleştirilebilir bildirim tercihleri.",
        "userManagementTitle": "Kullanıcı Yönetimi",
        "userManagementDesc": "Ekip üyelerinizi kolayca yönetin. Kullanıcı ekleme, rol atama, aktif kullanıcı görüntüleme ve multi-tenant firma yönetimi özellikleri.",
        
        // Screenshots Bölümü
        "screenshotsTitle": "Uygulamadan Görünümler",
        "screenshotsDescription": "Milestora'nın güçlü arayüzünü ve özelliklerini keşfedin",
        "supervisorPanelTitle": "Süpervizör Paneli",
        "supervisorPanelDesc": "Tüm firmaları ve kullanıcıları tek bir yerden yönetin",
        "dashboardTitle": "Dashboard",
        "dashboardDesc": "Tüm projelerinizi ve görevlerinizi bir bakışta görün",
        "projectDetailTitle": "Proje Detayı",
        "projectDetailDesc": "Kanban, Liste, Takvim, Gantt ve daha fazla görünüm modu",
        
        // Feature Badges
        "badgeSubtasks": "Alt Görevler",
        "badgeDependencies": "Bağımlılıklar",
        "badgeChecklist": "Checklist",
        "badgeSupervisor": "Supervisor",
        "badgeAdmin": "Admin",
        "badgeManager": "Manager",
        "badgeWeeklyView": "Haftalık Görünüm",
        "badgeWorkType": "İş Tipi",
        "badgeExcelExport": "Excel Export",
        "badgeCharts": "Grafikler",
        "badgeAuditTrail": "Audit Trail",
        "badgeSecurity": "Güvenlik",
        "badgeEmail": "Email",
        "badgeCustomizable": "Özelleştirilebilir",
        
        // Fiyatlandırma
        "pricingTitle": "Esnek Fiyatlandırma",
        "pricingDescription": "Ücretsiz başlayın, hazır olduğunuzda yükseltin",
        "mostPopular": "En Popüler",
        "perMonth": "ay",
        "perUser": "kullanıcı başına",
        "usersLimit": "{{count}} kullanıcıya kadar",
        "projectsLimit": "{{count}} projeye kadar",
        "unlimitedProjects": "Sınırsız proje",
        "storage": "{{size}} GB Depolama",
        "emailSupport": "E-posta Desteği",
        "prioritySupport": "Öncelikli Destek",
        "basicFeatures": "Temel Özellikler",
        "allFeatures": "Tüm Özellikler",
        "advancedFeatures": "Gelişmiş Özellikler",
        "apiAccess": "API Erişimi",
        "customIntegrations": "Özel Entegrasyonlar",
        "dedicatedSupport": "Özel Destek",
        "sla": "SLA Garantisi",
        "customDomain": "Özel Domain",
        "choosePlanButton": "Planı Seç",
        "contactUsButton": "Bize Ulaşın",
        
        // CTA Section
        "ctaTitle": "Dijital Dönüşümünüze Bugün Başlayın",
        "ctaDescription": "Milestora ile ekip verimliliğinizi artırın. Hemen kaydolun ve ilk projenizi ücretsiz yönetmeye başlayın!",
        "tryFree": "Ücretsiz Dene",
        
        // SSS
        "faqTitle": "Sıkça Sorulan Sorular",
        "faqDescription": "Milestora hakkında merak edilenler",
        "faqQuestion1": "Milestora nedir?",
        "faqAnswer1": "Milestora, Ener Yazılım tarafından geliştirilen profesyonel bulut tabanlı proje yönetim sistemidir. Görev takibi, zaman çizelgesi, Gantt chart, Kanban board ve detaylı raporlama özellikleri ile ekip verimliliğinizi artırır.",
        "faqQuestion2": "Ücretsiz plan ne kadar süreyle geçerlidir?",
        "faqAnswer2": "Başlangıç planımız tamamen ücretsizdir ve süresiz kullanabilirsiniz. 5 kullanıcıya kadar, 3 projeye kadar ücretsiz erişim sağlar. İhtiyacınıza göre ücretli planlara geçiş yapabilirsiniz.",
        "faqQuestion3": "Milestora hangi özellikleri sunuyor?",
        "faqAnswer3": "Çoklu proje yönetimi, görev takibi, alt görevler, bağımlılıklar, tekrarlayan görevler, Gantt chart, Kanban board, timeline görünümü, timesheet, kaynak yönetimi, detaylı raporlama, e-posta bildirimleri ve çok daha fazlası.",
        "faqQuestion4": "Verilerim güvende mi?",
        "faqAnswer4": "Evet, tüm verileriniz şifreli olarak saklanır ve düzenli yedeklenir. Güvenlik önlemlerimiz ve multi-tenant mimarisi sayesinde verileriniz tamamen izole ve güvendedir.",
        "faqQuestion5": "Mobil cihazlarda çalışır mı?",
        "faqAnswer5": "Evet, Milestora responsive tasarımı sayesinde mobil telefonlar, tabletler ve tüm ekran boyutlarında mükemmel çalışır. Tarayıcınız üzerinden her yerden erişebilirsiniz.",
        "faqQuestion6": "Destek alabilir miyim?",
        "faqAnswer6": "Kesinlikle! E-posta üzerinden destek alabilirsiniz: milestora@enerotomasyon.com.tr. Profesyonel ve Kurumsal planlarımızda öncelikli destek mevcuttur.",
        
        // Footer
        "footerDescription": "Profesyonel proje yönetim sistemi",
        "quickLinks": "Hızlı Linkler",
        "contact": "İletişim",
        "footerCopyright": "© 2024 Milestora · Ener Yazılım · Tüm hakları saklıdır.",
        
        // Pricing Plans
        "planFree": "Ücretsiz",
        "planProfessional": "Profesyonel",
        "planEnterprise": "Kurumsal",
        "planFreePeriod": "Sonsuza Kadar",
        "planProfessionalPeriod": "Ay",
        "planEnterprisePeriod": "Teklif",
        "planFreeDesc": "Küçük ekipler için ideal başlangıç",
        "planProfessionalDesc": "Büyüyen ekipler için güçlü özellikler",
        "planEnterpriseDesc": "Büyük organizasyonlar için özel çözümler",
        "priceCustom": "Özel",
        
        // Plan Features
        "feature5Users": "5 kullanıcıya kadar",
        "feature3Projects": "3 proje",
        "featureBasicTasks": "Temel görev yönetimi",
        "featureKanban": "Kanban görünümü",
        "featureEmailNotifications": "Email bildirimleri",
        "featureCommunitySupport": "7/24 topluluk desteği",
        "featureUnlimitedUsers": "Sınırsız kullanıcı",
        "featureUnlimitedProjects": "Sınırsız proje",
        "featureAllViews": "Tüm görünüm modları",
        "featureGantt": "Gantt Chart",
        "featureActivityLog": "Activity Log",
        "featureActiveUsers": "Aktif kullanıcı yönetimi",
        "featureAdvancedReporting": "Gelişmiş raporlama",
        "featureExcelExport": "Excel export",
        "featurePrioritySupport": "7/24 öncelikli destek",
        "featureAllProfessional": "Tüm Profesyonel özellikler",
        "featureSelfHosted": "Self-hosted seçeneği",
        "featureCustomDomain": "Özel domain",
        "featureAPIAccess": "API erişimi",
        "featureCustomIntegrations": "Özel entegrasyonlar",
        "featureDedicatedServer": "Dedicated server",
        "featureSLA": "SLA garantisi",
        "featureCustomTraining": "Özel eğitim",
        "featureTechnicalSupport": "7/24 teknik destek",
        "ctaStartFree": "Ücretsiz Başla",
        "ctaStartNow": "Hemen Başla",
        "ctaContactUs": "İletişime Geç",
        "pricingNote": "Tüm planlar 14 gün ücretsiz deneme içerir. Kredi kartı gerekmez.",
        "customQuote": "Özel Teklif İçin İletişime Geçin",
        
        // Why Milestora Section
        "whyMilestora": "Neden Milestora?",
        "openSourceSelfHosted": "Open Source ve Self-Hosted",
        "activityLogging": "Enterprise-grade Activity Logging",
        "multiTenantArchitecture": "Multi-tenant Mimari",
        "roleLevels": "5 Seviyeli Rol Yetkilendirme",
        "undoMechanism": "Undo Mekanizması ile Güvenli İşlemler",
        
        // CTA Trial Section
        "trialTitle": "14 Gün Ücretsiz Deneyin",
        "trialDescription": "Kredi kartı gerekmez. Anında başlayın, dilediğiniz zaman iptal edin.",
        
        // Company Info Section
        "companyTitle": "Ener Yazılım",
        "companyDescription": "Milestora, Ener Yazılım tarafından geliştirilmiş profesyonel bir proje yönetim sistemidir. Ekip verimliliğinizi artırın ve projelerinizi başarıyla tamamlayın.",
        "startFreeNow": "Ücretsiz Başla",
        "viewPricing": "Fiyatlandırmayı Gör"
      }
    }
  },
  en: {
    translation: {
      // Header
      "search": "Search...",
      "searchPlaceholder": "Search projects, tasks or documents... (Ctrl+K)",
      "notifications": "Notifications",
      "settings": "Settings",
      "logout": "Logout",
      
      // Search
      "searchResults": "Search Results",
      "noResults": "No results found",
      "searchIn": "Search in",
      "all": "All",
      "projects": "Projects",
      "tasks": "Tasks",
      "documents": "Documents",
      
      // Filters
      "filters": "Filters",
      "advancedFilters": "Advanced Filters",
      "savedFilters": "Saved Filters",
      "saveFilter": "Save Filter",
      "clearFilters": "Clear Filters",
      "applyFilters": "Apply Filters",
      "filterName": "Filter Name",
      "dateRange": "Date Range",
      "from": "From",
      "to": "To",
      "status": "Status",
      "priority": "Priority",
      "assignedTo": "Assigned To",
      "tags": "Tags",
      
      // Status
      "status.todo": "To Do",
      "status.in-progress": "In Progress",
      "status.done": "Done",
      "todo": "To Do",
      "inProgress": "In Progress",
      "done": "Done",
      
      // Priority
      "priority.low": "Low",
      "priority.medium": "Medium",
      "priority.high": "High",
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      
      // Task Detail
      "assignedPerson": "Assigned Person",
      "timeSpent": "Time Spent",
      "checklist": "Checklist",
      "checklistItems": "{{count}} items",
      "estimatedDates": "Estimated Dates",
      "actualDates": "Actual Dates",
      "estimatedStart": "Estimated Start",
      "estimatedEnd": "Estimated End",
      "actualStart": "Actual Start",
      "actualEnd": "Actual End",
      "notSet": "Not Set",
      "dateAndTime": "Date & Time",
      
      // Common
      "cancel": "Cancel",
      "save": "Save",
      "delete": "Delete",
      "edit": "Edit",
      "close": "Close",
      "apply": "Apply",
      "create": "Create",
      "update": "Update",
      "search": "Search",
      
      // Dashboard
      "dashboard": "Dashboard",
      "myProjects": "My Projects",
      "myTasks": "My Tasks",
      "reports": "Reports",
      "timesheets": "Timesheets",
      "templates": "Templates",
      "userManagement": "User Management",
      "supervisorPanel": "Supervisor Panel",
      
      // Mobile
      "menu": "Menu",
      "openMenu": "Open Menu",
      "closeMenu": "Close Menu",
      
      // Project Detail
      "projectDetail": "Project Detail",
      "newTask": "New Task",
      "createTask": "Create Task",
      "taskTitle": "Task Title",
      "taskDescription": "Description",
      "selectAssignee": "Select Assignee",
      "selectPriority": "Select Priority",
      "selectStatus": "Select Status",
      "estimatedDates": "Estimated Dates",
      "startDate": "Start Date",
      "endDate": "End Date",
      "duration": "Duration",
      "days": "Days",
      "hours": "Hours",
      
      // View Modes
      "kanban": "Kanban",
      "list": "List",
      "calendar": "Calendar",
      "timeline": "Timeline",
      "gantt": "Gantt",
      
      // Task Card
      "dueDate": "Due Date",
      "comments": "Comments",
      "attachments": "Attachments",
      
      // Dashboard Stats
      "companyTotalProjects": "Company Total Projects",
      "companyProjectsDesc": "All projects company-wide",
      "userCreatedProjects": "Your Created Projects",
      "projectsYouCreated": "Projects you initiated",
      "userCreatedTasks": "Your Created Tasks",
      "tasksYouCreated": "Tasks you created",
      "userAssignedTasks": "Tasks Assigned to You",
      "tasksAssignedToYou": "Tasks you're working on",
      "notStarted": "Not Started",
      "todoTasks": "Tasks not yet started",
      "ongoingTasks": "Tasks in progress",
      "completed": "Completed",
      "finishedTasks": "Completed tasks",
      "taskStatus": "Task Status",
      "allTasks": "All tasks in the system",
      "projectProgress": "Project Progress",
      "recentProjects": "Completion rates of your recent projects",
      
      // Legacy (for backward compatibility)
      "totalProjects": "Total Projects",
      "totalTasks": "Total Tasks",
      "assignedToYou": "Assigned to You",
      "createdByYou": "Created by You",
      "yourProjects": "Number of projects you're a member of",
      "activeTasks": "Your active tasks",
      "tasksCreatedByYou": "Tasks created by you",
      
      // Projects
      "newProject": "New Project",
      "createProject": "Create Project",
      "projectName": "Project Name",
      "projectDescription": "Description",
      "noProjects": "No projects yet",
      "createdAt": "Created",
      
      // SMTP Settings
      "smtpSettings": "SMTP Settings",
      "emailServerConfig": "Email server configuration",
      "emailServerSettings": "Email Server Settings",
      "configureSMTP": "Configure SMTP settings specific to your company. Notification emails will be sent according to these settings.",
      "smtpServer": "SMTP Server",
      "smtpPort": "SMTP Port",
      "username": "Username",
      "usernameEmail": "Username (Email)",
      "senderEmail": "Sender Email",
      "senderName": "Sender Name",
      "useSTARTTLS": "Use STARTTLS",
      "useSSLTLS": "Use SSL/TLS",
      "recommendedPort587": "Recommended for port 587",
      "recommendedPort465": "Recommended for port 465",
      "exampleServers": "e.g. smtp.gmail.com, smtp.yandex.com",
      "ifEmptyUsername": "Username will be used if left empty",
      "nameInEmails": "Name that will appear in emails",
      "companyName": "Company Name",
      "gmailImportantNote": "Important Note for Gmail",
      "gmailAppPassword": "If you're using Gmail, you need to create an \"App Password\" from your Google account. Your regular Gmail password won't work.",
      "useAppPasswordGmail": "Use App Password for Gmail",
      "testConnection": "Test Connection",
      "saveSettings": "Save Settings",
      "smtpSaved": "SMTP settings saved",
      "smtpSaveFailed": "Failed to save SMTP settings",
      "connectionSuccess": "Connection successful!",
      "connectionFailed": "Connection failed",
      
      // ProjectDetail & Tasks
      "notProjectMember": "You are not a member of this project",
      "projectLoadFailed": "Failed to load project",
      "tasksLoadFailed": "Failed to load tasks",
      "usersLoadFailed": "Failed to load users",
      "commentsLoadFailed": "Failed to load comments",
      "taskCreated": "Task created!",
      "statusUpdated": "Status updated",
      "statusUpdateFailed": "Failed to update status",
      "confirmDeleteTask": "Are you sure you want to delete this task?",
      "taskDeleted": "Task deleted",
      
      // Templates
      "templatesLoadFailed": "Failed to load templates",
      "templateNameRequired": "Template name and task title are required",
      "templateUpdated": "Template updated",
      "templateCreated": "Template created",
      "templateUpdateFailed": "Failed to update template",
      "templateCreateFailed": "Failed to create template",
      "confirmDeleteTemplate": "Are you sure you want to delete this template?",
      "templateDeleted": "Template deleted",
      "templateDeleteFailed": "Failed to delete template",
      "editTemplate": "Edit Template",
      "createNewTemplate": "Create New Template",
      
      // Supervisor Panel
      "dataLoadFailed": "Failed to load data",
      "companyCreated": "Company created!",
      "companyCreateFailed": "Failed to create company",
      "adminCreated": "Admin user created!",
      "adminCreateFailed": "Failed to create admin",
      "companyActivated": "Company activated",
      "companyDeactivated": "Company deactivated",
      "operationFailed": "Operation failed",
      "companyUpdated": "Company updated!",
      "companyUpdateFailed": "Failed to update company",
      "updatedAt": "Updated",
      "employer": "Employer",
      "upperEmployer": "Upper Employer",
      "mainContractor": "Main Contractor",
      "optional": "Optional",
      "employerPlaceholder": "Employer name",
      "upperEmployerPlaceholder": "Upper employer name (if any)",
      "mainContractorPlaceholder": "Main contractor name (if any)",
      "editProject": "Edit Project",
      "editProjectDescription": "Update project information",
      "deleteProject": "Delete Project",
      "deleteProjectTitle": "Permanently Delete Project",
      "deleteProjectWarning": "This action cannot be undone! The project and ALL related data will be permanently deleted.",
      "deleteProjectImpact": "Data to be deleted:",
      "allTasksWillBeDeleted": "All tasks",
      "allSubtasksWillBeDeleted": "All subtasks",
      "allCommentsWillBeDeleted": "All comments",
      "allTimeLogsWillBeDeleted": "All time logs",
      "allNotificationsWillBeDeleted": "All notifications",
      "allDocumentsWillBeDeleted": "All documents",
      "typeProjectNameToConfirm": "Type project name to confirm",
      "deleteProjectPermanently": "Delete Project Permanently",
      "saveChanges": "Save Changes",
      
      // Settings
      "accountSettings": "Account Settings",
      "changePassword": "Change Password",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmPassword": "Confirm Password",
      "updatePassword": "Update Password",
      "emailNotifications": "Email Notifications",
      "taskAssigned": "Task Assigned",
      "taskCommented": "Task Commented",
      "taskStatusChanged": "Task Status Changed",
      "memberAdded": "Member Added",
      "profilePicture": "Profile Picture",
      "profilePictureDescription": "Upload your profile photo (JPG or PNG, max 5MB)",
      "profilePictureHint": "JPG or PNG format, maximum 5MB",
      "uploadPicture": "Upload Picture",
      "deletePicture": "Delete Picture",
      "uploading": "Uploading...",
      "profilePictureUploaded": "Profile picture uploaded",
      "profilePictureDeleted": "Profile picture deleted",
      "invalidFileType": "Invalid file format. Only image files are supported",
      "fileTooLarge": "File too large. Maximum 5MB",
      "selectFile": "Please select a file",
      "uploadFailed": "Upload failed",
      "deleteFailed": "Delete failed",
      "members": "members",
      "searchProjects": "Search projects...",
      "filterProjects": "Filter",
      "allProjects": "All Projects",
      "memberProjects": "Member Projects",
      "noProjectsFound": "No projects found",
      "tryDifferentSearch": "Try a different search or filter",
      "created": "Created",
      "estimatedStart": "Estimated Start",
      "actualStart": "Actual Start",
      
      // Resources
      "resourceManagement": "Resource Management",
      "resources": "Resources",
      "addResource": "Add Resource",
      "editResource": "Edit Resource",
      "deleteResource": "Delete Resource",
      "resourceType": "Resource Type",
      "resourceFormDescription": "Enter resource information",
      "searchResources": "Search resources...",
      "noResourcesFound": "No resources found",
      "addFirstResource": "Add First Resource",
      "resourceCreated": "Resource created",
      "resourceUpdated": "Resource updated",
      "resourceDeleted": "Resource deleted",
      "resourcesLoadFailed": "Resources load failed",
      "confirmDeleteResource": "Are you sure you want to delete this resource?",
      "human": "Human Resource",
      "equipment": "Equipment",
      "material": "Material",
      "financial": "Financial",
      "time": "Time",
      "knowledge": "Knowledge",
      "digital": "Digital",
      "available": "Available",
      "in_use": "In Use",
      "maintenance": "Maintenance",
      "unavailable": "Unavailable",
      "role": "Role",
      "hourlyRate": "Hourly Rate",
      "capacity": "Capacity",
      "hoursPerWeek": "Hours/Week",
      "serialNumber": "Serial Number",
      "costPerUse": "Cost Per Use",
      "location": "Location",
      "stockQuantity": "Stock Quantity",
      "unit": "Unit",
      "unitPrice": "Unit Price",
      "unitPlaceholder": "e.g. pcs, kg, m",
      "totalBudget": "Total Budget",
      "costCenter": "Cost Center",
      
      // User Management
      "addUser": "Add User",
      "userName": "Name",
      "userEmail": "Email",
      "userRole": "Role",
      "actions": "Actions",
      "selectRole": "Select Role",
      "manager": "Manager",
      "engineer": "Engineer",
      "personnel": "Personnel",
      "member": "Personnel",  // Backward compatibility
      
      // Login
      "login": "Login",
      "email": "Email",
      "password": "Password",
      "welcomeBack": "Welcome Back",
      "loginToAccount": "Login to your account",
      "loading": "Please wait",
      
      // Settings
      "profileSettings": "Profile Settings",
      "passwordSettings": "Password Settings",
      "notificationSettings": "Notification Settings",
      "fullName": "Full Name",
      "emailAddress": "Email Address",
      "taskAssignedNotif": "Notify when task assigned",
      "commentNotif": "Notify when task commented",
      "statusChangedNotif": "Notify when task status changed",
      "memberAddedNotif": "Notify when member added",
      "passwordMismatch": "Passwords do not match",
      "passwordMinLength": "Password must be at least 6 characters",
      "passwordChanged": "Password changed successfully",
      "savingChanges": "Saving...",
      "changingPassword": "Changing...",
      
      // Reports
      "reportsDashboard": "Reports",
      "selectReport": "Select Report",
      "burndownChart": "Burndown Chart",
      "memberPerformance": "Member Performance",
      "timeTracking": "Time Tracking",
      "exportExcel": "Export to Excel",
      "selectProject": "Select Project",
      "generateReport": "Generate Report",
      "backToDashboard": "Back to Dashboard",
      "charts": "Charts",
      "performance": "Performance",
      "timeReport": "Time Report",
      "costBurn": "Cost Burn",
      "utilization": "Utilization",
      "export": "Export",
      "selectProjectPlaceholder": "Select a project",
      "projectRequired": "Please select a project",
      "dataLoadFailed": "Failed to load data",
      "timeline": "Timeline",
      "statusDistribution": "Status Distribution",
      "priorityDistribution": "Priority Distribution",
      "burndown": "Burndown",
      "taskCreation": "Task Creation",
      "tasksCompleted": "Tasks Completed",
      "tasksCreated": "Tasks Created",
      "remaining": "Remaining",
      "ideal": "Ideal",
      "assignedTasks": "Assigned Tasks",
      "completedTasks": "Completed Tasks",
      "completionRate": "Completion Rate",
      "avgTime": "Avg Time",
      "noDataAvailable": "No data available",
      "exportAllData": "Export All Data",
      "exportTasks": "Export Tasks",
      "exportProjects": "Export Projects",
      "exportMembers": "Export Members",
      "exportCostBurn": "Export Cost Burn",
      "exportAllocations": "Export Allocations",
      "exporting": "Exporting...",
      "exportSuccess": "Export successful",
      "exportFailed": "Export failed",
      
      // Templates
      "taskTemplates": "Task Templates",
      "createTemplate": "Create Template",
      "templateName": "Template Name",
      "templateDescription": "Template Description",
      "addTask": "Add Task",
      "noTemplates": "No templates yet",
      "useTemplate": "Use Template",
      
      // User Management
      "addNewUser": "Add New User",
      "editUser": "Edit User",
      "deleteUser": "Delete User",
      "confirmDelete": "Are you sure you want to delete?",
      "userAdded": "User added",
      "userUpdated": "User updated",
      "userDeleted": "User deleted",
      
      // SMTP Settings
      "smtpSettings": "SMTP Settings",
      "smtpHost": "SMTP Server",
      "smtpPort": "SMTP Port",
      "smtpUser": "SMTP User",
      "smtpPassword": "SMTP Password",
      "useSSL": "Use SSL",
      "testConnection": "Test Connection",
      "smtpSaved": "SMTP settings saved",
      
      // Supervisor Panel
      "companyManagement": "Company Management",
      "totalCompanies": "Total Companies",
      "activeCompanies": "Active Companies",
      "totalUsers": "Total Users",
      "companyName": "Company Name",
      "companyEmail": "Company Email",
      "companyPhone": "Company Phone",
      "companyAddress": "Company Address",
      "addCompany": "Add Company",
      "editCompany": "Edit Company",
      "deleteCompany": "Delete Company",
      "companyActive": "Active",
      "companyPassive": "Passive",
      "adminUser": "Admin User",
      "addAdmin": "Add Admin",
      
      // Common Actions
      "description": "Description",
      "active": "Active",
      "inactive": "Inactive",
      "yes": "Yes",
      "no": "No",
      "confirm": "Confirm",
      "success": "Success",
      "error": "Error",
      
      // Task Dependencies
      "taskDependencies": "Task Dependencies",
      "complete": "Complete",
      "taskBlocked": "This task depends on other tasks",
      "waitingForTasks": "Waiting for {{count}} task(s) to complete",
      "taskImpact": "This task is blocking {{count}} task(s)",
      "graphView": "Graph View",
      "listView": "List View",
      "thisTaskDependsOn": "This task depends on",
      "thisTaskBlocking": "This task is blocking",
      "addDependency": "Add Dependency",
      "selectTask": "Select task",
      "noAvailableTasks": "No tasks available to add",
      "add": "Add",
      "dependencyHelpText": "This task will depend on the selected task and cannot move to 'In Progress' until it's completed.",
      "noDependenciesYet": "No dependencies yet",
      "noDependenciesDescription": "Organize your workflow by creating dependencies between tasks",
      "pleaseSelectTask": "Please select a task",
      "dependencyAdded": "Dependency added",
      "dependencyAddFailed": "Failed to add dependency",
      "dependencyRemoved": "Dependency removed",
      "dependencyRemoveFailed": "Failed to remove dependency",
      "noDependencies": "No dependencies yet",
      "filters": "Filters",
      "advancedFilters": "Advanced Filters",
      "savedFilters": "Saved Filters",
      "saveFilter": "Save Filter",
      "clearFilters": "Clear Filters",
      "applyFilters": "Apply Filters",
      "filterName": "Filter Name",
      "dateRange": "Date Range",
      "from": "From",
      "to": "To",
      "status": "Status",
      "priority": "Priority",
      "assignedTo": "Assigned To",
      "tags": "Tags",
      
      // Status
      "status.todo": "To Do",
      "status.in-progress": "In Progress",
      "status.done": "Done",
      "todo": "To Do",
      "inProgress": "In Progress",
      "done": "Done",
      
      // Priority
      "priority.low": "Low",
      "priority.medium": "Medium",
      "priority.high": "High",
      "low": "Low",
      "medium": "Medium",
      "high": "High",
      
      // Task Detail
      "assignedPerson": "Assigned Person",
      "timeSpent": "Time Spent",
      "checklist": "Checklist",
      "checklistItems": "{{count}} items",
      "estimatedDates": "Estimated Dates",
      "actualDates": "Actual Dates",
      "estimatedStart": "Estimated Start",
      "estimatedEnd": "Estimated End",
      "actualStart": "Actual Start",
      "actualEnd": "Actual End",
      "notSet": "Not Set",
      "dateAndTime": "Date & Time",
      
      // Common
      "cancel": "Cancel",
      "save": "Save",
      "delete": "Delete",
      "edit": "Edit",
      "close": "Close",
      "apply": "Apply",
      "create": "Create",
      "update": "Update",
      "search": "Search",
      
      // Dashboard
      "dashboard": "Dashboard",
      "myProjects": "My Projects",
      "myTasks": "My Tasks",
      "reports": "Reports",
      "timesheets": "Timesheets",
      "templates": "Templates",
      "userManagement": "User Management",
      "supervisorPanel": "Supervisor Panel",
      
      // Mobile
      "menu": "Menu",
      "openMenu": "Open Menu",
      "closeMenu": "Close Menu",
      
      // Project Detail
      "projectDetail": "Project Details",
      "newTask": "New Task",
      "createTask": "Create Task",
      "taskTitle": "Task Title",
      "taskDescription": "Description",
      "selectAssignee": "Select Assignee",
      "selectPriority": "Select Priority",
      "selectStatus": "Select Status",
      "estimatedDates": "Estimated Dates",
      "startDate": "Start Date",
      "endDate": "End Date",
      "duration": "Duration",
      "days": "Days",
      "hours": "Hours",
      
      // View Modes
      "kanban": "Kanban",
      "list": "List",
      "calendar": "Calendar",
      "timeline": "Timeline",
      "gantt": "Gantt",
      
      // Task Card
      "assignedTo": "Assigned To",
      "dueDate": "Due Date",
      "comments": "Comments",
      "attachments": "Attachments",
      
      // Dashboard Stats
      "companyTotalProjects": "Company Total Projects",
      "companyProjectsDesc": "All projects across the company",
      "userCreatedProjects": "Projects You Created",
      "projectsYouCreated": "Projects initiated by you",
      "userCreatedTasks": "Tasks You Created",
      "tasksYouCreated": "Tasks created by you",
      "userAssignedTasks": "Tasks Assigned to You",
      "tasksAssignedToYou": "Tasks on your plate",
      "notStarted": "Not Started",
      "todoTasks": "Tasks not yet started",
      "ongoingTasks": "Tasks in progress",
      "completed": "Completed",
      "finishedTasks": "Finished tasks",
      "taskStatus": "Task Status",
      "allTasks": "All tasks in system",
      "projectProgress": "Project Progress",
      "recentProjects": "Completion rates of recent projects",
      
      // Legacy (for backward compatibility)
      "totalProjects": "Total Projects",
      "totalTasks": "Total Tasks",
      "assignedToYou": "Tasks Assigned to You",
      "createdByYou": "Tasks Created by You",
      "yourProjects": "Number of projects you're member of",
      "activeTasks": "Your active tasks",
      "tasksCreatedByYou": "Tasks created by you",
      
      // Projects
      "newProject": "New Project",
      "createProject": "Create Project",
      "projectName": "Project Name",
      "projectDescription": "Description",
      "noProjects": "No projects yet",
      "createdAt": "Created At",
      "updatedAt": "Updated At",
      "employer": "Employer",
      "upperEmployer": "Upper Employer",
      "mainContractor": "Main Contractor",
      "optional": "Optional",
      "employerPlaceholder": "Employer name",
      "upperEmployerPlaceholder": "Upper employer name (if any)",
      "mainContractorPlaceholder": "Main contractor name (if any)",
      "editProject": "Edit Project",
      "editProjectDescription": "Update project information",
      "deleteProject": "Delete Project",
      "deleteProjectTitle": "Permanently Delete Project",
      "deleteProjectWarning": "This action cannot be undone! The project and ALL associated data will be permanently deleted.",
      "deleteProjectImpact": "Data to be deleted:",
      "allTasksWillBeDeleted": "All tasks",
      "allSubtasksWillBeDeleted": "All subtasks",
      "allCommentsWillBeDeleted": "All comments",
      "allTimeLogsWillBeDeleted": "All time logs",
      "allNotificationsWillBeDeleted": "All notifications",
      "allDocumentsWillBeDeleted": "All documents",
      "typeProjectNameToConfirm": "Type project name to confirm",
      "deleteProjectPermanently": "Delete Project Permanently",
      "saveChanges": "Save Changes",
      
      // Resources
      "resourceManagement": "Resource Management",
      "resources": "Resources",
      "addResource": "Add Resource",
      "editResource": "Edit Resource",
      "deleteResource": "Delete Resource",
      "resourceType": "Resource Type",
      "resourceFormDescription": "Enter resource information",
      "searchResources": "Search resources...",
      "noResourcesFound": "No resources found",
      "addFirstResource": "Add First Resource",
      "resourceCreated": "Resource created",
      "resourceUpdated": "Resource updated",
      "resourceDeleted": "Resource deleted",
      "resourcesLoadFailed": "Failed to load resources",
      "confirmDeleteResource": "Are you sure you want to delete this resource?",
      "human": "Human Resource",
      "equipment": "Equipment",
      "material": "Material",
      "financial": "Financial",
      "time": "Time",
      "knowledge": "Knowledge",
      "digital": "Digital",
      "available": "Available",
      "in_use": "In Use",
      "maintenance": "Maintenance",
      "unavailable": "Unavailable",
      "role": "Role",
      "hourlyRate": "Hourly Rate",
      "capacity": "Capacity",
      "hoursPerWeek": "Hours/Week",
      "serialNumber": "Serial Number",
      "costPerUse": "Cost Per Use",
      "location": "Location",
      "stockQuantity": "Stock Quantity",
      "unit": "Unit",
      "unitPrice": "Unit Price",
      "unitPlaceholder": "e.g. pcs, kg, m",
      "totalBudget": "Total Budget",
      "costCenter": "Cost Center",
      
      // Settings
      "accountSettings": "Account Settings",
      "changePassword": "Change Password",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmPassword": "Confirm Password",
      "updatePassword": "Update Password",
      "emailNotifications": "Email Notifications",
      "taskAssigned": "Task Assigned",
      "taskCommented": "Task Commented",
      "taskStatusChanged": "Task Status Changed",
      "memberAdded": "Member Added",
      "profilePicture": "Profile Picture",
      "profilePictureDescription": "Upload your profile photo (JPG or PNG, max 5MB)",
      "profilePictureHint": "JPG or PNG format, maximum 5MB",
      "uploadPicture": "Upload Picture",
      "deletePicture": "Delete Picture",
      "uploading": "Uploading...",
      "profilePictureUploaded": "Profile picture uploaded",
      "profilePictureDeleted": "Profile picture deleted",
      "invalidFileType": "Invalid file type. Only image files are supported",
      "fileTooLarge": "File too large. Maximum 5MB",
      "selectFile": "Please select a file",
      "uploadFailed": "Upload failed",
      "deleteFailed": "Delete failed",
      "members": "members",
      "searchProjects": "Search projects...",
      "filterProjects": "Filter",
      "allProjects": "All Projects",
      "myProjects": "My Projects",
      "memberProjects": "Member Projects",
      "noProjectsFound": "No projects found",
      "tryDifferentSearch": "Try a different search or filter",
      "created": "Created",
      "estimatedStart": "Estimated Start",
      "actualStart": "Actual Start",
      
      // User Management
      "addUser": "Add User",
      "userName": "Name",
      "userEmail": "Email",
      "userRole": "Role",
      "actions": "Actions",
      "selectRole": "Select Role",
      "manager": "Manager",
      "engineer": "Engineer",
      "personnel": "Personnel",
      "member": "Personnel",  // Backward compatibility
      
      // Login
      "login": "Login",
      "email": "Email",
      "password": "Password",
      "welcomeBack": "Welcome Back",
      "loginToAccount": "Sign in to your account",
      "loading": "Please wait",
      
      // Settings
      "profileSettings": "Profile Settings",
      "passwordSettings": "Password Settings",
      "notificationSettings": "Notification Settings",
      "fullName": "Full Name",
      "emailAddress": "Email Address",
      "saveChanges": "Save Changes",
      "taskAssignedNotif": "Notify when task is assigned",
      "commentNotif": "Notify when task is commented",
      "statusChangedNotif": "Notify when task status changes",
      "memberAddedNotif": "Notify when member is added",
      "passwordMismatch": "Passwords don't match",
      "passwordMinLength": "Password must be at least 6 characters",
      "passwordChanged": "Password changed successfully",
      "savingChanges": "Saving...",
      "changingPassword": "Changing...",
      
      // Reports
      "reportsDashboard": "Reports",
      "selectReport": "Select Report",
      "burndownChart": "Burndown Chart",
      "memberPerformance": "Member Performance",
      "timeTracking": "Time Tracking",
      "exportExcel": "Export to Excel",
      "selectProject": "Select Project",
      "allProjects": "All Projects",
      "generateReport": "Generate Report",
      
      // Templates
      "taskTemplates": "Task Templates",
      "createTemplate": "Create Template",
      "templateName": "Template Name",
      "templateDescription": "Template Description",
      "addTask": "Add Task",
      "noTemplates": "No templates yet",
      "useTemplate": "Use Template",
      
      // User Management
      "userManagement": "User Management",
      "addNewUser": "Add New User",
      "editUser": "Edit User",
      "deleteUser": "Delete User",
      "confirmDelete": "Are you sure you want to delete?",
      "userAdded": "User added",
      "userUpdated": "User updated",
      "userDeleted": "User deleted",
      
      // SMTP Settings
      "smtpSettings": "SMTP Settings",
      "smtpHost": "SMTP Host",
      "smtpPort": "SMTP Port",
      "smtpUser": "SMTP User",
      "smtpPassword": "SMTP Password",
      "useSSL": "Use SSL",
      "testConnection": "Test Connection",
      "smtpSaved": "SMTP settings saved",
      
      // Supervisor Panel
      "supervisorPanel": "Supervisor Panel",
      "companyManagement": "Company Management",
      "totalCompanies": "Total Companies",
      "activeCompanies": "Active Companies",
      "totalUsers": "Total Users",
      "companyName": "Company Name",
      "companyEmail": "Company Email",
      "companyPhone": "Company Phone",
      "companyAddress": "Company Address",
      "addCompany": "Add Company",
      "editCompany": "Edit Company",
      "deleteCompany": "Delete Company",
      "companyActive": "Active",
      "companyPassive": "Passive",
      "adminUser": "Admin User",
      "addAdmin": "Add Admin",
      
      
      // Billing & Subscription
      "billing": {
        "title": "Billing and Subscription",
        "currentPlan": "Current Plan",
        "currentPlanDesc": "Your active subscription details",
        "nextBilling": "Next Billing Date",
        "autoRenew": "Auto Renewal",
        "cancelSubscription": "Cancel Subscription",
        "noSubscription": "You don't have an active subscription yet",
        "upgradePlan": "Upgrade Plan",
        "availablePlans": "Available Plans",
        "availablePlansDesc": "Choose the plan that suits you",
        "free": "Free",
        "month": "Month",
        "year": "Year",
        "selectPlan": "Select Plan",
        "contactSales": "Contact Sales",
        "paymentHistory": "Payment History",
        "paymentHistoryDesc": "Your past payments",
        "noPayments": "No payments yet",
        "payment": "Payment",
        "completePayment": "Complete Payment",
        "creditCard": "Credit Card",
        "bankTransfer": "Bank Transfer / EFT",
        "cardHolder": "Card Holder",
        "cardHolderPlaceholder": "Full Name",
        "cardNumber": "Card Number",
        "expiryMonth": "Month",
        "expiryYear": "Year",
        "testCards": "Test Cards",
        "success": "Success",
        "failed": "Failed",
        "bankTransferInfo": "Bank Transfer / EFT Information",
        "yourBankName": "Your Bank Name",
        "bankNamePlaceholder": "e.g. Garanti BBVA",
        "yourIban": "Your IBAN",
        "referenceNumber": "Reference Number",
        "referencePlaceholder": "Your payment reference",
        "bankTransferNote": "After your bank transfer, it will be manually approved by our system administrator. This process may take 1-2 business days.",
        "processing": "Processing...",
        "payNow": "Pay Now",
        "submitTransfer": "Submit Transfer Details",
        "fillAllFields": "Please fill all fields",
        "paymentSuccess": "Payment successful!",
        "paymentFailed": "Payment failed",
        "bankTransferCreated": "Your transfer record has been created. Your subscription will be activated after approval.",
        "paymentError": "An error occurred while processing payment",
        "confirmCancel": "Are you sure you want to cancel your subscription?",
        "subscriptionCancelled": "Subscription cancelled",
        "cancelError": "Cancellation failed",
        "autoRenewUpdated": "Auto-renewal setting updated",
        "autoRenewError": "Error updating setting",
        "noCompany": "Company information not found",
        "fetchError": "Error loading information",
        "bankLabel": "Bank",
        "ibanLabel": "IBAN",
        "receiverLabel": "Receiver",
        "bankValue": "Garanti BBVA",
        "ibanValue": "TR33 0062 1000 0000 0006 2956 35",
        "receiverValue": "Ener Yazılım Electronic Information Security Technologies Inc.",
        "statusActive": "Active",
        "statusPending": "Pending",
        "statusCancelled": "Cancelled",
        "statusSuccess": "Success",
        "statusFailed": "Failed"
      },
      // Common Actions
      "description": "Description",
      "active": "Active",
      "inactive": "Inactive",
      "yes": "Yes",
      "no": "No",
      "confirm": "Confirm",
      "success": "Success",
      "error": "Error",
      
      // Task Dependencies
      "taskDependencies": "Task Dependencies",
      "complete": "Complete",
      "taskBlocked": "This task is blocked by dependencies",
      "waitingForTasks": "Waiting for {{count}} task(s) to complete",
      "taskImpact": "This task is blocking {{count}} task(s)",
      "graphView": "Graph View",
      "listView": "List View",
      "thisTaskDependsOn": "This task depends on",
      "thisTaskBlocking": "This task is blocking",
      "addDependency": "Add Dependency",
      "selectTask": "Select a task",
      "noAvailableTasks": "No available tasks",
      "add": "Add",
      "dependencyHelpText": "This task will depend on the selected task and cannot move to 'In Progress' until it is completed.",
      "noDependenciesYet": "No dependencies yet",
      "noDependenciesDescription": "Create dependencies between tasks to organize your workflow",
      "pleaseSelectTask": "Please select a task",
      "dependencyAdded": "Dependency added",
      "dependencyAddFailed": "Failed to add dependency",
      "dependencyRemoved": "Dependency removed",
      "dependencyRemoveFailed": "Failed to remove dependency",
      "noDependencies": "No dependencies yet",
      "currentTask": "Current Task",
      "blockedBy": "Depends On",
      "blocking": "Blocking",
      "thisTask": "This Task",
      "dependsOnConnection": "Dependency connection",
      "blockingConnection": "Blocking connection",
      
      // Timesheets
      "timesheets": "Timesheets",
      "workingHours": "Working Hours",
      "logDailyHours": "Log your daily working hours",
      "week": "Week",
      "previousWeek": "Previous Week",
      "nextWeek": "Next Week",
      "totalHours": "Total Hours",
      "regularHours": "Regular Hours",
      "overtimeHours": "Overtime Hours",
      "recordCount": "Record Count",
      "newRecord": "New Record",
      "editRecord": "Edit",
      "task": "Task",
      "required": "Required",
      "taskOptional": "Task (Optional)",
      "selectTaskOrLeaveEmpty": "Select task or leave empty",
      "projectLevel": "Project level",
      "noTaskSelected": "Leave empty to log project-level work",
      "date": "Date",
      "workType": "Work Type",
      "normalWork": "Normal Work",
      "overtime": "Overtime",
      "weekend": "Weekend",
      "holiday": "Holiday",
      "pleaseEnterProjectAndHours": "Please enter project and hours information",
      "timesheetUpdated": "Timesheet updated",
      "timesheetSaved": "Timesheet saved",
      "timesheetDeleted": "Timesheet deleted",
      "deleteFailed": "Delete failed",
      "deleteConfirm": "Are you sure you want to delete this record?",
      "weeklyView": "Weekly View",
      "today": "Today",
      "noRecords": "No records",
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected",
      "normal": "Normal",
      "weekendWork": "Weekend",
      "holidayWork": "Holiday",
      
      // Access Control
      "accessDenied": "Access Denied",
      "noPermission": "You don't have permission to access this page",
      
      // User Management Additional
      "usersLoadFailed": "Failed to load users",
      "userCreated": "User created!",
      "userCreateFailed": "Failed to create user",
      "userUpdated": "User updated!",
      "userUpdateFailed": "Failed to update user",
      "userDeleted": "User deleted!",
      "userDeleteFailed": "Failed to delete user",
      "enterName": "Enter name",
      "strongPassword": "Strong password",
      "createNewUser": "Create New User",
      "createUserForCompany": "Create a new user for your company",
      "fullName": "Full Name",
      "password": "Password",
      "role": "Role",
      "createUser": "Create User",
      "editUserTitle": "Edit User",
      "updateUser": "Update User",
      "roleDescriptions": "Manager: Project management, Engineer: Task management, Member: Task tracking",
      "totalUsers": "Total Users",
      "engineer": "Engineer",
      "personnel": "Personnel",
      "users": "Users",
      "allCompanyUsers": "All users in the company",
      "newUser": "New User",
      "adminCannotEdit": "Admin cannot be edited",
      "createdAt": "Created",
      
      // Projects
      "projectsLoadFailed": "Failed to load projects",
      "projectCreated": "Project created!",
      "projectCreateFailed": "Failed to create project",
      "projectUpdated": "Project updated!",
      "projectUpdateFailed": "Failed to update project",
      "noUpdatePermission": "You don't have permission to update this project",
      "projectNameMismatch": "Project name mismatch",
      "projectDeleted": "Project and all related data deleted",
      "noDescription": "No description",
      
      // Sprint & Resources
      "sprintManagement": "Sprint Management",
      "resourceSearch": "Resource Search",
      "manageProjectSprints": "Manage your project sprints",
      "findResourcesBySkills": "Find resources by skills and availability",
      "newSprint": "New Sprint",
      "editSprint": "Edit Sprint",
      "sprintName": "Sprint Name",
      "sprintGoal": "Sprint Goal",
      "writeSprintGoal": "Write sprint goal...",
      "sprintStatus": "Sprint Status",
      "planned": "Planned",
      "active": "Active",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "sprintCreated": "Sprint created",
      "sprintUpdated": "Sprint updated",
      "sprintDeleted": "Sprint deleted",
      "sprintStarted": "Sprint started",
      "confirmDeleteSprint": "Are you sure you want to delete this sprint?",
      "taskCount": "Task Count",
      "selectProject": "Select Project",
      "noSprintsYet": "No sprints yet",
      "createFirstSprint": "Create your first sprint",
      "sprintsLoadFailed": "Failed to load sprints",
      "fillRequiredFields": "Please fill all required fields (* marked)",
      "endDateAfterStart": "End date must be after start date",
      "sprintStartedEmailSent": "Sprint started! Emails sent.",
      "sprintStatusUpdated": "Sprint status updated",
      "statusUpdateFailed": "Failed to update status",
      "sprintDeleteFailed": "Failed to delete sprint",
      
      // Resource Search
      "resourceType": "Resource Type",
      "skill": "Skill",
      "minLevel": "Min Level",
      "availableFrom": "Available From",
      "availableTo": "Available To",
      "searchResourceName": "Resource name...",
      "searchResults": "Search Results",
      "noResourcesFound": "No resources found",
      "skills": "Skills",
      "availability": "Availability",
      
      // ProjectDetail Additional
      "taskTitleRequired": "Please enter task title (* marked field is required)",
      "taskCreationFailed": "Failed to create task",
      "commentAdded": "Comment added",
      "commentAddFailed": "Failed to add comment",
      "confirmDeleteTaskMsg": "Are you sure you want to delete this task?",
      "cannotDeleteOnlyCreator": "You don't have permission to delete this task. Only the creator can delete it.",
      "taskDeleteFailed": "Failed to delete task",
      "timeSaved": "Time saved",
      "timeSaveFailed": "Failed to save time",
      "startedAt": "Started",
      "finishedAt": "Finished",
      "noTimeRecordedYet": "No time recorded yet",
      "changeStatus": "Change Status",
      "addTime": "Add Time",
      "send": "Send",
      "deleteTask": "Delete Task",
      "fromTemplate": "From Template",
      "manageResources": "Manage Resources",
      "projectResources": "Project Resources",
      "resourceManagementInfo": "ℹ️ Click 'Manage Resources' button for detailed resource management, reservation and assignment.",
      "enterTaskDetails": "Enter task details",
      "selectUserOptional": "Select user (optional)",
      "unassigned": "Unassigned",
      "selectSprintOptional": "Select sprint (optional)",
      "noSprint": "No Sprint",
      "selectDate": "Select date",
      "ganttPlanningOptional": "Gantt Planning (Optional)",
      "hide": "Hide",
      "show": "Show",
      "estimatedStartDate": "Estimated Start Date",
      "defaultCreationDate": "Default: Creation Date",
      "estimatedDurationDays": "Estimated Duration (Days)",
      "estimatedDurationHours": "Estimated Duration (Hours)",
      "estimatedEndDate": "Estimated End Date",
      "durationOrManual": "Enter duration or select manually",
      "durationAutoCalculateHint": "💡 Duration is auto-calculated. If both duration and end date are provided, the later date will be used.",
      "startTask": "Start Task",
      "completeTask": "Complete Task",
      "taskStarted": "Task started!",
      "taskStartFailed": "Failed to start task",
      "taskCompleted": "Task completed!",
      "taskCompleteFailed": "Failed to complete task",
      "addComment": "Add comment...",
      "minutesShort": "m",
      "hoursShort": "h",
      "membersTab": "Members",
      "documentsTab": "Documents",
      
      // Templates Additional
      "backToDashboard": "Back to Dashboard",
      "taskTemplates": "Task Templates",
      "saveTemplatesDesc": "Save frequently used task structures as templates",
      "newTemplate": "New Template",
      "editTemplateTitle": "Edit Template",
      "createNewTemplateTitle": "Create New Template",
      "templateFormDesc": "Fill in template information. You can quickly create tasks from this template.",
      "templateNameLabel": "Template Name *",
      "templateNamePlaceholder": "e.g. Sprint Planning Task",
      "templateDescLabel": "Template Description",
      "templateDescPlaceholder": "What is this template used for?",
      "taskTitleLabel": "Task Title *",
      "taskTitlePlaceholder": "Title of the task to be created",
      "taskDescLabel": "Task Description",
      "taskDescPlaceholder": "Description of the task to be created",
      "priorityLabel": "Priority",
      "tagsLabel": "Tags",
      "tagsPlaceholder": "sprint, planning, meeting",
      "separateWithCommas": "Separate with commas",
      "saving": "Saving...",
      "updating": "Updating",
      "creating": "Creating",
      "loading": "Loading...",
      "noTemplatesYet": "No templates yet",
      "createFirstTemplate": "Create your first template to save frequently used task structures",
      "taskTitleColon": "Task Title:",
      "descriptionColon": "Description:",
      
      // SupervisorPanel Additional
      "noAccessToPage": "You don't have access to this page",
      "companyCreationFailed": "Failed to create company",
      "adminCreationFailed": "Failed to create admin",
      "companyDeactivated": "Company deactivated",
      "companyActivated": "Company activated",
      "operationFailed": "Operation failed",
      "usersLoadFailed": "Failed to load users",
      "confirmDeleteCompany": "Are you sure you want to delete {{companyName}} company and all its data? This action cannot be undone!",
      "companyDeletedSummary": "Company deleted! {{users}} users, {{projects}} projects, {{tasks}} tasks were deleted.",
      "companyDeleteFailed": "Failed to delete company",
      "confirmDeleteUser": "Are you sure you want to delete {{userName}} user?",
      "cannotDeleteUser": "Cannot delete user",
      "adminRole": "Admin",
      "managerRole": "Manager",
      "engineerRole": "Engineer",
      "personnelRole": "Personnel",
      "supervisorPanel": "Supervisor Panel",
      "companySystemManagement": "Company and system management",
      "logout": "Logout",
      "totalCompanies": "Total Companies",
      "activeCompany": "Active Company",
      "totalUsers": "Total Users",
      "totalProjects": "Total Projects",
      "totalTasks": "Total Tasks",
      "companiesTitle": "Companies",
      "allSystemCompanies": "All companies in the system",
      "newCompany": "New Company",
      "noCompaniesYet": "No companies added yet",
      "activeStatus": "Active",
      "passiveStatus": "Passive",
      "adminUsers": "Admin Users",
      "usersButton": "Users",
      "adminButton": "Admin",
      "editButton": "Edit",
      "passiveButton": "Passive",
      "activeButton": "Active",
      "createNewCompany": "Create New Company",
      "addNewCompanyToSystem": "Add a new company to the system",
      "companyNameLabel": "Company Name *",
      "companyNamePlaceholder": "Example Software Ltd.",
      "emailLabel": "Email *",
      "emailPlaceholder": "info@example.com",
      "phoneLabel": "Phone",
      "phonePlaceholder": "+90 555 123 4567",
      "addressLabel": "Address",
      "addressPlaceholder": "Istanbul, Turkey",
      "createCompanyButton": "Create Company",
      "editCompanyTitle": "Edit Company",
      "updateCompanyInfo": "Update company information",
      "updateCompanyButton": "Update Company",
      "createCompanyAdmin": "Create Company Admin",
      "createAdminForCompany": "Create admin user for {{companyName}}",
      "fullNameLabel": "Full Name *",
      "fullNamePlaceholder": "Ahmet Yilmaz",
      "passwordLabel": "Password *",
      "strongPasswordPlaceholder": "Strong password",
      "createAdminButton": "Create Admin User",
      "companyUsers": "Company Users",
      "companyUsersCount": "{{companyName}} - Total {{count}} users",
      "noUsersInCompany": "No users in this company yet",
      "createdAtLabel": "Created:",
      "editUserTitle": "Edit User",
      "updateUserInfo": "Update user information",
      "roleLabel": "Role *",
      "selectRoleLabel": "Select role",
      "updateUserButton": "Update User",
      "taskDetailsManagement": "Task details and management options",
      "templatesLoadFailed": "Failed to load templates",
      "templateNameTaskTitleRequired": "Template name and task title are required",
      "confirmDeleteTemplate": "Are you sure you want to delete this template?",
      "dataLoadFailed": "Failed to load data",
      "companyCreated": "Company created!",
      "adminUserCreated": "Admin user created!",
      "companyUpdated": "Company updated!",
      "userUpdated": "User updated!",
      "userDeleted": "User deleted!",
      "userUpdateFailed": "Failed to update user",
      "backToHome": "Back to Home",
      "back": "Back",
      
      // Register Page
      "register": "Register",
      "registerTitle": "Get Started Today",
      "registerDescription": "Create your account and boost your team productivity",
      "companyName": "Company Name",
      "companyNamePlaceholder": "e.g. Acme Software Inc.",
      "industry": "Industry",
      "selectIndustry": "Select an industry",
      "nameSurname": "Name Surname",
      "namePlaceholder": "John Doe",
      "phoneNumber": "Phone Number",
      "phonePlaceholder": "+90 555 123 4567",
      "phoneHelpText": "Enter your phone number in international format",
      "passwordHelpText": "Minimum 6 characters",
      "registerButton": "Create Account",
      "registering": "Creating...",
      "registerSuccess": "Registration successful!",
      "registerFailed": "Registration failed",
      "fillAllFields": "Please fill in all fields",
      "companyInfo": "Company Information",
      "adminUserInfo": "Admin User Information",
      "createCompanyButton": "Create Company & Start",
      "alreadyHaveAccount": "Already have an account?",
      "loginLink": "Login",
      "startInstantly": "Start Instantly",
      "startInstantlyDesc": "No installation required, start using immediately",
      "free14Days": "14 Days Free",
      "free14DaysDesc": "No credit card required, no risk",
      "fullFeatures": "Full Features",
      "fullFeaturesDesc": "Complete access to all premium features",
      
      // Industries
      "industryTechnology": "Technology",
      "industrySoftware": "Software",
      "industryEcommerce": "E-Commerce",
      "industryConstruction": "Construction",
      "industryManufacturing": "Manufacturing",
      "industryHealthcare": "Healthcare",
      "industryEducation": "Education",
      "industryFinance": "Finance",
      "industryConsulting": "Consulting",
      "industryMedia": "Media",
      "industryTourism": "Tourism",
      "industryLogistics": "Logistics",
      "industryRetail": "Retail",
      "industryOther": "Other",
      
      // Landing Page
      "landing": {
        "features": "Features",
        "pricing": "Pricing",
        "login": "Login",
        "start": "Start",
        "startFree": "Start Free",
        "cloudBadge": "☁️ Cloud-Based SaaS Solution",
        "heroTitle": "Manage Projects",
        "heroSubtitle": "in the Cloud",
        "heroDescription": "Professional project management system ready to use instantly, no installation required. Start free, scale as you grow.",
        "startFreeButton": "Start Free",
        "discoverFeatures": "Discover Features",
        
        // Stats
        "activeUsers": "Active Users",
        "completedProjects": "Completed Projects",
        "teamSatisfaction": "Team Satisfaction",
        "uptimeRate": "Uptime Rate",
        
        // Features
        "featuresTitle": "Powerful Features",
        "featuresDescription": "Features that simplify project management and boost team productivity",
        "multiUserManagement": "Multi-User Management",
        "multiUserManagementDesc": "Comprehensive authorization with Supervisor, Admin, Manager, Engineer, Personnel roles",
        "multipleViews": "Multiple Views",
        "multipleViewsDesc": "Kanban, List, Calendar, Timeline, Gantt - Choose the view that suits you best",
        "taskManagement": "Task Management",
        "taskManagementDesc": "Subtasks, dependencies, recurring tasks, checklist support",
        "timesheetTracking": "Timesheet Tracking",
        "timesheetTrackingDesc": "Detailed time tracking and reporting for each task",
        "reportingAnalytics": "Reporting & Analytics",
        "reportingAnalyticsDesc": "Instant reports and performance analysis",
        "teamCollaboration": "Team Collaboration",
        "teamCollaborationDesc": "Comments, notifications, file sharing",
        
        // Detailed Features
        "detailedFeaturesTitle": "Detailed Features",
        "detailedFeaturesDescription": "Take your project management to the next level with Milestora",
        "projectTaskManagementTitle": "Project & Task Management",
        "projectTaskManagementDesc": "Keep your projects fully under control with comprehensive task management. Plan every detail with subtasks, dependencies, recurring tasks, and checklist support.",
        "roleBasedAccessTitle": "Role-Based Access Control",
        "roleBasedAccessDesc": "Assign appropriate authorizations to your team members with 5 different role levels (Supervisor, Admin, Manager, Engineer, Personnel). Create a secure and organized work environment.",
        "timesheetManagementTitle": "Timesheet Management",
        "timesheetManagementDesc": "Record working hours with detailed time tracking. Professional timesheet management with weekly view, work type distinction (regular, overtime, weekend, holiday), and approval process.",
        "reportingTitle": "Reporting & Analytics",
        "reportingDesc": "Track project performance with real-time reports and analytics. Make data-driven decisions with Excel export, charts, and detailed statistics.",
        "activityLogTitle": "Activity Logging",
        "activityLogDesc": "Record and track all operations in the system. Who did what and when? Comprehensive activity logging system for audit and security.",
        "notificationSystemTitle": "Notification System",
        "notificationSystemDesc": "Get instantly notified about task assignments, comments, status changes with email notifications. Customizable notification preferences.",
        "userManagementTitle": "User Management",
        "userManagementDesc": "Easily manage your team members. User addition, role assignment, active user viewing, and multi-tenant company management features.",
        
        // Screenshots Section
        "screenshotsTitle": "Views from the Application",
        "screenshotsDescription": "Explore Milestora's powerful interface and features",
        "supervisorPanelTitle": "Supervisor Panel",
        "supervisorPanelDesc": "Manage all companies and users from a single place",
        "dashboardTitle": "Dashboard",
        "dashboardDesc": "See all your projects and tasks at a glance",
        "projectDetailTitle": "Project Detail",
        "projectDetailDesc": "Kanban, List, Calendar, Gantt and more view modes",
        
        // Feature Badges
        "badgeSubtasks": "Subtasks",
        "badgeDependencies": "Dependencies",
        "badgeChecklist": "Checklist",
        "badgeSupervisor": "Supervisor",
        "badgeAdmin": "Admin",
        "badgeManager": "Manager",
        "badgeWeeklyView": "Weekly View",
        "badgeWorkType": "Work Type",
        "badgeExcelExport": "Excel Export",
        "badgeCharts": "Charts",
        "badgeAuditTrail": "Audit Trail",
        "badgeSecurity": "Security",
        "badgeEmail": "Email",
        "badgeCustomizable": "Customizable",
        
        "teamCollaborationDesc": "Comments, notifications, file sharing",
        
        // Pricing
        "pricingTitle": "Flexible Pricing",
        "pricingDescription": "Start free, upgrade when you're ready",
        "mostPopular": "Most Popular",
        "perMonth": "month",
        "perUser": "per user",
        "usersLimit": "Up to {{count}} users",
        "projectsLimit": "Up to {{count}} projects",
        "unlimitedProjects": "Unlimited projects",
        "storage": "{{size}} GB Storage",
        "emailSupport": "Email Support",
        "prioritySupport": "Priority Support",
        "basicFeatures": "Basic Features",
        "allFeatures": "All Features",
        "advancedFeatures": "Advanced Features",
        "apiAccess": "API Access",
        "customIntegrations": "Custom Integrations",
        "dedicatedSupport": "Dedicated Support",
        "sla": "SLA Guarantee",
        "customDomain": "Custom Domain",
        "choosePlanButton": "Choose Plan",
        "contactUsButton": "Contact Us",
        
        // CTA Section
        "ctaTitle": "Start Your Digital Transformation Today",
        "ctaDescription": "Increase your team productivity with Milestora. Sign up now and start managing your first project for free!",
        "tryFree": "Try Free",
        
        // FAQ
        "faqTitle": "Frequently Asked Questions",
        "faqDescription": "Curious about Milestora",
        "faqQuestion1": "What is Milestora?",
        "faqAnswer1": "Milestora is a professional cloud-based project management system developed by Ener Yazılım. It increases team productivity with task tracking, timeline, Gantt chart, Kanban board, and detailed reporting features.",
        "faqQuestion2": "How long is the free plan valid?",
        "faqAnswer2": "Our Starter plan is completely free and you can use it indefinitely. It provides free access for up to 5 users and up to 3 projects. You can upgrade to paid plans as needed.",
        "faqQuestion3": "What features does Milestora offer?",
        "faqAnswer3": "Multi-project management, task tracking, subtasks, dependencies, recurring tasks, Gantt chart, Kanban board, timeline view, timesheet, resource management, detailed reporting, email notifications, and much more.",
        "faqQuestion4": "Is my data secure?",
        "faqAnswer4": "Yes, all your data is stored encrypted and backed up regularly. Thanks to our security measures and multi-tenant architecture, your data is completely isolated and secure.",
        "faqQuestion5": "Does it work on mobile devices?",
        "faqAnswer5": "Yes, thanks to Milestora's responsive design, it works perfectly on mobile phones, tablets, and all screen sizes. You can access it from anywhere via your browser.",
        "faqQuestion6": "Can I get support?",
        "faqAnswer6": "Absolutely! You can get support via email: milestora@enerotomasyon.com.tr. Priority support is available in our Professional and Enterprise plans.",
        
        // Footer
        "footerDescription": "Professional project management system",
        "quickLinks": "Quick Links",
        "contact": "Contact",
        "footerCopyright": "© 2024 Milestora · Ener Yazılım · All rights reserved.",
        
        // Pricing Plans
        "planFree": "Free",
        "planProfessional": "Professional",
        "planEnterprise": "Enterprise",
        "planFreePeriod": "Forever",
        "planProfessionalPeriod": "Month",
        "planEnterprisePeriod": "Quote",
        "planFreeDesc": "Perfect starter for small teams",
        "planProfessionalDesc": "Powerful features for growing teams",
        "planEnterpriseDesc": "Custom solutions for large organizations",
        "priceCustom": "Custom",
        
        // Plan Features
        "feature5Users": "Up to 5 users",
        "feature3Projects": "3 projects",
        "featureBasicTasks": "Basic task management",
        "featureKanban": "Kanban view",
        "featureEmailNotifications": "Email notifications",
        "featureCommunitySupport": "24/7 community support",
        "featureUnlimitedUsers": "Unlimited users",
        "featureUnlimitedProjects": "Unlimited projects",
        "featureAllViews": "All view modes",
        "featureGantt": "Gantt Chart",
        "featureActivityLog": "Activity Log",
        "featureActiveUsers": "Active user management",
        "featureAdvancedReporting": "Advanced reporting",
        "featureExcelExport": "Excel export",
        "featurePrioritySupport": "24/7 priority support",
        "featureAllProfessional": "All Professional features",
        "featureSelfHosted": "Self-hosted option",
        "featureCustomDomain": "Custom domain",
        "featureAPIAccess": "API access",
        "featureCustomIntegrations": "Custom integrations",
        "featureDedicatedServer": "Dedicated server",
        "featureSLA": "SLA guarantee",
        "featureCustomTraining": "Custom training",
        "featureTechnicalSupport": "24/7 technical support",
        "ctaStartFree": "Start Free",
        "ctaStartNow": "Start Now",
        "ctaContactUs": "Contact Us",
        "pricingNote": "All plans include a 14-day free trial. No credit card required.",
        "customQuote": "Contact Us for Custom Pricing",
        
        // Why Milestora Section
        "whyMilestora": "Why Milestora?",
        "openSourceSelfHosted": "Open Source & Self-Hosted",
        "activityLogging": "Enterprise-grade Activity Logging",
        "multiTenantArchitecture": "Multi-tenant Architecture",
        "roleLevels": "5-Level Role Authorization",
        "undoMechanism": "Secure Operations with Undo",
        
        // CTA Trial Section
        "trialTitle": "Try Free for 14 Days",
        "trialDescription": "No credit card required. Start instantly, cancel anytime.",
        
        // Company Info Section
        "companyTitle": "Ener Yazılım",
        "companyDescription": "Milestora is a professional project management system developed by Ener Yazılım. Increase your team productivity and successfully complete your projects.",
        "startFreeNow": "Start Free",
        "viewPricing": "View Pricing"
      }
    }
  },
  ar: {
    translation: {
      // Common
      "backToHome": "العودة إلى الصفحة الرئيسية",
      "back": "رجوع",

      // Register Page
      "register": "تسجيل",
      "registerTitle": "ابدأ الآن",
      "registerDescription": "أنشئ حسابك وزد من إنتاجية فريقك",
      "companyName": "اسم الشركة",
      "companyNamePlaceholder": "مثال: شركة أكمي للبرمجيات",
      "industry": "القطاع",
      "selectIndustry": "اختر القطاع",
      "nameSurname": "الاسم الكامل",
      "namePlaceholder": "أحمد محمد",
      "phoneNumber": "رقم الهاتف",
      "phonePlaceholder": "+966 55 123 4567",
      "phoneHelpText": "أدخل رقم هاتفك بالصيغة الدولية",
      "passwordHelpText": "6 أحرف على الأقل",
      "registerButton": "إنشاء حساب",
      "registering": "جارٍ الإنشاء...",
      "registerSuccess": "تم التسجيل بنجاح!",
      "registerFailed": "فشل التسجيل",
      "fillAllFields": "يرجى ملء جميع الحقول",
      "companyInfo": "معلومات الشركة",
      "adminUserInfo": "معلومات المسؤول",
      "createCompanyButton": "إنشاء الشركة والبدء",
      "alreadyHaveAccount": "هل لديك حساب بالفعل؟",
      "loginLink": "تسجيل الدخول",
      "startInstantly": "ابدأ فوراً",
      "startInstantlyDesc": "لا حاجة للإعداد، ابدأ الاستخدام فوراً",
      "free14Days": "14 يوم مجاناً",
      "free14DaysDesc": "لا حاجة لبطاقة ائتمان، بدون مخاطر",
      "fullFeatures": "ميزات كاملة",
      "fullFeaturesDesc": "وصول كامل لجميع الميزات المميزة",

      // Industries
      "industryTechnology": "التكنولوجيا",
      "industrySoftware": "البرمجيات",
      "industryEcommerce": "التجارة الإلكترونية",
      "industryConstruction": "البناء",
      "industryManufacturing": "التصنيع",
      "industryHealthcare": "الرعاية الصحية",
      "industryEducation": "التعليم",
      "industryFinance": "المالية",
      "industryConsulting": "الاستشارات",
      "industryMedia": "الإعلام",
      "industryTourism": "السياحة",
      "industryLogistics": "اللوجستيات",
      "industryRetail": "التجزئة",
      "industryOther": "أخرى",

      // Header
      "search": "بحث...",
      "searchPlaceholder": "ابحث عن مشاريع أو مهام أو مستندات... (Ctrl+K)",
      "notifications": "الإشعارات",
      "settings": "الإعدادات",
      "logout": "تسجيل الخروج",

      // Search
      "searchResults": "نتائج البحث",
      "noResults": "لا توجد نتائج",
      "searchIn": "البحث في",
      "all": "الكل",
      "projects": "المشاريع",
      "tasks": "المهام",
      "documents": "المستندات",

      // Filters
      "filters": "الفلاتر",
      "advancedFilters": "فلاتر متقدمة",
      "savedFilters": "الفلاتر المحفوظة",
      "saveFilter": "حفظ الفلتر",
      "clearFilters": "مسح الفلاتر",
      "applyFilters": "تطبيق الفلاتر",
      "filterName": "اسم الفلتر",
      "dateRange": "نطاق التاريخ",
      "from": "من",
      "to": "إلى",
      "status": "الحالة",
      "priority": "الأولوية",
      "assignedTo": "مُسند إلى",
      "tags": "العلامات",

      // Status
      "status.todo": "للتنفيذ",
      "status.in-progress": "قيد التنفيذ",
      "status.done": "مكتمل",
      "todo": "للتنفيذ",
      "inProgress": "قيد التنفيذ",
      "done": "مكتمل",

      // Priority
      "priority.low": "منخفضة",
      "priority.medium": "متوسطة",
      "priority.high": "عالية",
      "low": "منخفضة",
      "medium": "متوسطة",
      "high": "عالية",

      // Task Detail
      "assignedPerson": "الشخص المُسند",
      "timeSpent": "الوقت المستغرق",
      "checklist": "قائمة التحقق",
      "checklistItems": "{{count}} عناصر",
      "estimatedDates": "التواريخ المقدرة",
      "actualDates": "التواريخ الفعلية",
      "estimatedStart": "البداية المقدرة",
      "estimatedEnd": "النهاية المقدرة",
      "actualStart": "البداية الفعلية",
      "actualEnd": "النهاية الفعلية",
      "notSet": "غير محدد",
      "dateAndTime": "التاريخ والوقت",

      // Common
      "cancel": "إلغاء",
      "save": "حفظ",
      "delete": "حذف",
      "edit": "تعديل",
      "close": "إغلاق",
      "apply": "تطبيق",
      "create": "إنشاء",
      "update": "تحديث",

      // Dashboard
      "dashboard": "لوحة التحكم",
      "myProjects": "مشاريعي",
      "myTasks": "مهامي",
      "reports": "التقارير",
      "timesheets": "سجلات الوقت",
      "templates": "القوالب",
      "userManagement": "إدارة المستخدمين",
      "supervisorPanel": "لوحة المشرف",

      // Mobile
      "menu": "القائمة",
      "openMenu": "فتح القائمة",
      "closeMenu": "إغلاق القائمة",

      // Project Detail
      "projectDetail": "تفاصيل المشروع",
      "newTask": "مهمة جديدة",
      "createTask": "إنشاء مهمة",
      "taskTitle": "عنوان المهمة",
      "taskDescription": "الوصف",
      "selectAssignee": "اختر المُسند إليه",
      "selectPriority": "اختر الأولوية",
      "selectStatus": "اختر الحالة",
      "startDate": "تاريخ البدء",
      "endDate": "تاريخ الانتهاء",
      "duration": "المدة",
      "days": "أيام",
      "hours": "ساعات",

      // View Modes
      "kanban": "كانبان",
      "list": "قائمة",
      "calendar": "تقويم",
      "timeline": "جدول زمني",
      "gantt": "غانت",

      // Task Card
      "dueDate": "تاريخ الاستحقاق",
      "comments": "التعليقات",
      "attachments": "المرفقات",

      // Dashboard Stats
      "companyTotalProjects": "إجمالي مشاريع الشركة",
      "companyProjectsDesc": "جميع المشاريع على مستوى الشركة",
      "userCreatedProjects": "المشاريع التي أنشأتها",
      "projectsYouCreated": "المشاريع التي بدأتها",
      "userCreatedTasks": "المهام التي أنشأتها",
      "tasksYouCreated": "المهام التي أنشأتها",
      "userAssignedTasks": "المهام المُسندة إليك",
      "tasksAssignedToYou": "المهام التي تعمل عليها",
      "notStarted": "لم تبدأ",
      "todoTasks": "المهام التي لم تبدأ بعد",
      "ongoingTasks": "المهام الجارية",
      "completed": "مكتمل",
      "finishedTasks": "المهام المنجزة",
      "taskStatus": "حالة المهمة",
      "allTasks": "جميع المهام في النظام",
      "projectProgress": "تقدم المشروع",
      "recentProjects": "معدلات إنجاز مشاريعك الأخيرة",

      // Legacy
      "totalProjects": "إجمالي المشاريع",
      "totalTasks": "إجمالي المهام",
      "assignedToYou": "مُسند إليك",
      "createdByYou": "أنشأتها",
      "yourProjects": "عدد المشاريع التي أنت عضو فيها",
      "activeTasks": "مهامك النشطة",
      "tasksCreatedByYou": "المهام التي أنشأتها",

      // Projects
      "newProject": "مشروع جديد",
      "createProject": "إنشاء مشروع",
      "projectName": "اسم المشروع",
      "projectDescription": "الوصف",
      "noProjects": "لا توجد مشاريع بعد",
      "createdAt": "تاريخ الإنشاء",

      // Login
      "login": "تسجيل الدخول",
      "email": "البريد الإلكتروني",
      "password": "كلمة المرور",
      "welcomeBack": "مرحباً بعودتك",
      "loginToAccount": "سجل الدخول إلى حسابك",
      "loading": "يرجى الانتظار",

      // Settings
      "profileSettings": "إعدادات الملف الشخصي",
      "passwordSettings": "إعدادات كلمة المرور",
      "notificationSettings": "إعدادات الإشعارات",
      "fullName": "الاسم الكامل",
      "emailAddress": "عنوان البريد الإلكتروني",
      "saveChanges": "حفظ التغييرات",
      "accountSettings": "إعدادات الحساب",
      "changePassword": "تغيير كلمة المرور",
      "currentPassword": "كلمة المرور الحالية",
      "newPassword": "كلمة المرور الجديدة",
      "confirmPassword": "تأكيد كلمة المرور",
      "updatePassword": "تحديث كلمة المرور",

      // User Management
      "addUser": "إضافة مستخدم",
      "userName": "الاسم",
      "userEmail": "البريد الإلكتروني",
      "userRole": "الدور",
      "actions": "الإجراءات",
      "selectRole": "اختر الدور",
      "manager": "مدير",
      "engineer": "مهندس",
      "personnel": "موظف",
      "member": "موظف",

      // Common Actions
      "description": "الوصف",
      "active": "نشط",
      "inactive": "غير نشط",
      "yes": "نعم",
      "no": "لا",
      "confirm": "تأكيد",
      "success": "نجاح",
      "error": "خطأ",
      "add": "إضافة",
      "role": "الدور",

      // Landing Page
      "landing": {
        "features": "الميزات",
        "pricing": "الأسعار",
        "login": "تسجيل الدخول",
        "start": "ابدأ",
        "startFree": "ابدأ مجاناً",
        "cloudBadge": "☁️ حل سحابي SaaS",
        "heroTitle": "إدارة المشاريع",
        "heroSubtitle": "في السحابة",
        "heroDescription": "نظام إدارة مشاريع احترافي جاهز للاستخدام الفوري بدون إعداد. ابدأ مجاناً وتوسع حسب احتياجاتك.",
        "startFreeButton": "ابدأ مجاناً",
        "discoverFeatures": "اكتشف الميزات",
        "activeUsers": "مستخدم نشط",
        "completedProjects": "مشروع مكتمل",
        "teamSatisfaction": "رضا الفريق",
        "uptimeRate": "وقت التشغيل",
        "featuresTitle": "ميزات قوية",
        "featuresDescription": "ميزات تسهل إدارة المشاريع وتزيد إنتاجية الفريق",
        "multiUserManagement": "إدارة متعددة المستخدمين",
        "multiUserManagementDesc": "تفويض شامل مع أدوار المشرف والمسؤول والمدير والمهندس والموظف",
        "multipleViews": "عروض متعددة",
        "multipleViewsDesc": "كانبان، قائمة، تقويم، جدول زمني، غانت - اختر العرض المناسب لك",
        "taskManagement": "إدارة المهام",
        "taskManagementDesc": "المهام الفرعية، التبعيات، المهام المتكررة، دعم قائمة التحقق",
        "timesheetTracking": "تتبع الوقت",
        "timesheetTrackingDesc": "تتبع الوقت التفصيلي والتقارير لكل مهمة",
        "reportingAnalytics": "التقارير والتحليلات",
        "reportingAnalyticsDesc": "تقارير فورية وتحليل الأداء",
        "teamCollaboration": "تعاون الفريق",
        "teamCollaborationDesc": "التعليقات والإشعارات ومشاركة الملفات",
        "pricingTitle": "أسعار مرنة",
        "pricingDescription": "ابدأ مجاناً، قم بالترقية عندما تكون مستعداً",
        "mostPopular": "الأكثر شعبية",
        "perMonth": "شهرياً",
        "planFree": "مجاني",
        "planProfessional": "احترافي",
        "planEnterprise": "مؤسسي",
        "ctaTitle": "ابدأ تحولك الرقمي اليوم",
        "ctaDescription": "زد إنتاجية فريقك مع Milestora. سجل الآن وابدأ إدارة مشروعك الأول مجاناً!",
        "tryFree": "جرب مجاناً",
        "faqTitle": "الأسئلة الشائعة",
        "faqDescription": "ما يُسأل عنه حول Milestora",
        "footerDescription": "نظام إدارة مشاريع احترافي",
        "quickLinks": "روابط سريعة",
        "contact": "اتصل بنا"
      }
    }
  },
  ru: {
    translation: {
      // Common
      "backToHome": "Вернуться на главную",
      "back": "Назад",

      // Register Page
      "register": "Регистрация",
      "registerTitle": "Начните сейчас",
      "registerDescription": "Создайте аккаунт и повысьте продуктивность команды",
      "companyName": "Название компании",
      "companyNamePlaceholder": "напр. ООО Acme Software",
      "industry": "Отрасль",
      "selectIndustry": "Выберите отрасль",
      "nameSurname": "ФИО",
      "namePlaceholder": "Иван Иванов",
      "phoneNumber": "Номер телефона",
      "phonePlaceholder": "+7 999 123 4567",
      "phoneHelpText": "Введите номер телефона в международном формате",
      "passwordHelpText": "Минимум 6 символов",
      "registerButton": "Создать аккаунт",
      "registering": "Создание...",
      "registerSuccess": "Регистрация успешна!",
      "registerFailed": "Ошибка регистрации",
      "fillAllFields": "Пожалуйста, заполните все поля",
      "companyInfo": "Информация о компании",
      "adminUserInfo": "Информация администратора",
      "createCompanyButton": "Создать компанию и начать",
      "alreadyHaveAccount": "Уже есть аккаунт?",
      "loginLink": "Войти",
      "startInstantly": "Начните мгновенно",
      "startInstantlyDesc": "Без установки, начните использовать сразу",
      "free14Days": "14 дней бесплатно",
      "free14DaysDesc": "Без кредитной карты, без риска",
      "fullFeatures": "Полный функционал",
      "fullFeaturesDesc": "Полный доступ ко всем премиум-функциям",

      // Industries
      "industryTechnology": "Технологии",
      "industrySoftware": "Программное обеспечение",
      "industryEcommerce": "Электронная коммерция",
      "industryConstruction": "Строительство",
      "industryManufacturing": "Производство",
      "industryHealthcare": "Здравоохранение",
      "industryEducation": "Образование",
      "industryFinance": "Финансы",
      "industryConsulting": "Консалтинг",
      "industryMedia": "Медиа",
      "industryTourism": "Туризм",
      "industryLogistics": "Логистика",
      "industryRetail": "Розничная торговля",
      "industryOther": "Другое",

      // Header
      "search": "Поиск...",
      "searchPlaceholder": "Поиск проектов, задач или документов... (Ctrl+K)",
      "notifications": "Уведомления",
      "settings": "Настройки",
      "logout": "Выход",

      // Search
      "searchResults": "Результаты поиска",
      "noResults": "Ничего не найдено",
      "searchIn": "Искать в",
      "all": "Все",
      "projects": "Проекты",
      "tasks": "Задачи",
      "documents": "Документы",

      // Filters
      "filters": "Фильтры",
      "advancedFilters": "Расширенные фильтры",
      "savedFilters": "Сохраненные фильтры",
      "saveFilter": "Сохранить фильтр",
      "clearFilters": "Очистить фильтры",
      "applyFilters": "Применить фильтры",
      "filterName": "Название фильтра",
      "dateRange": "Период",
      "from": "От",
      "to": "До",
      "status": "Статус",
      "priority": "Приоритет",
      "assignedTo": "Назначено",
      "tags": "Теги",

      // Status
      "status.todo": "К выполнению",
      "status.in-progress": "В работе",
      "status.done": "Готово",
      "todo": "К выполнению",
      "inProgress": "В работе",
      "done": "Готово",

      // Priority
      "priority.low": "Низкий",
      "priority.medium": "Средний",
      "priority.high": "Высокий",
      "low": "Низкий",
      "medium": "Средний",
      "high": "Высокий",

      // Task Detail
      "assignedPerson": "Исполнитель",
      "timeSpent": "Затраченное время",
      "checklist": "Чек-лист",
      "checklistItems": "{{count}} элементов",
      "estimatedDates": "Планируемые даты",
      "actualDates": "Фактические даты",
      "estimatedStart": "Планируемое начало",
      "estimatedEnd": "Планируемое окончание",
      "actualStart": "Фактическое начало",
      "actualEnd": "Фактическое окончание",
      "notSet": "Не указано",
      "dateAndTime": "Дата и время",

      // Common
      "cancel": "Отмена",
      "save": "Сохранить",
      "delete": "Удалить",
      "edit": "Редактировать",
      "close": "Закрыть",
      "apply": "Применить",
      "create": "Создать",
      "update": "Обновить",

      // Dashboard
      "dashboard": "Панель управления",
      "myProjects": "Мои проекты",
      "myTasks": "Мои задачи",
      "reports": "Отчеты",
      "timesheets": "Табели",
      "templates": "Шаблоны",
      "userManagement": "Управление пользователями",
      "supervisorPanel": "Панель руководителя",

      // Mobile
      "menu": "Меню",
      "openMenu": "Открыть меню",
      "closeMenu": "Закрыть меню",

      // Project Detail
      "projectDetail": "Детали проекта",
      "newTask": "Новая задача",
      "createTask": "Создать задачу",
      "taskTitle": "Название задачи",
      "taskDescription": "Описание",
      "selectAssignee": "Выбрать исполнителя",
      "selectPriority": "Выбрать приоритет",
      "selectStatus": "Выбрать статус",
      "startDate": "Дата начала",
      "endDate": "Дата окончания",
      "duration": "Длительность",
      "days": "Дней",
      "hours": "Часов",

      // View Modes
      "kanban": "Канбан",
      "list": "Список",
      "calendar": "Календарь",
      "timeline": "Временная шкала",
      "gantt": "Гант",

      // Task Card
      "dueDate": "Срок",
      "comments": "Комментарии",
      "attachments": "Вложения",

      // Dashboard Stats
      "companyTotalProjects": "Всего проектов компании",
      "companyProjectsDesc": "Все проекты компании",
      "userCreatedProjects": "Созданные вами проекты",
      "projectsYouCreated": "Проекты, которые вы создали",
      "userCreatedTasks": "Созданные вами задачи",
      "tasksYouCreated": "Задачи, которые вы создали",
      "userAssignedTasks": "Назначенные вам задачи",
      "tasksAssignedToYou": "Задачи, над которыми вы работаете",
      "notStarted": "Не начато",
      "todoTasks": "Задачи, которые еще не начаты",
      "ongoingTasks": "Задачи в работе",
      "completed": "Завершено",
      "finishedTasks": "Завершенные задачи",
      "taskStatus": "Статус задачи",
      "allTasks": "Все задачи в системе",
      "projectProgress": "Прогресс проекта",
      "recentProjects": "Показатели завершения недавних проектов",

      // Legacy
      "totalProjects": "Всего проектов",
      "totalTasks": "Всего задач",
      "assignedToYou": "Назначено вам",
      "createdByYou": "Создано вами",
      "yourProjects": "Количество проектов, в которых вы участвуете",
      "activeTasks": "Ваши активные задачи",
      "tasksCreatedByYou": "Задачи, созданные вами",

      // Projects
      "newProject": "Новый проект",
      "createProject": "Создать проект",
      "projectName": "Название проекта",
      "projectDescription": "Описание",
      "noProjects": "Проектов пока нет",
      "createdAt": "Создано",

      // Login
      "login": "Вход",
      "email": "Email",
      "password": "Пароль",
      "welcomeBack": "С возвращением",
      "loginToAccount": "Войдите в свой аккаунт",
      "loading": "Подождите",

      // Settings
      "profileSettings": "Настройки профиля",
      "passwordSettings": "Настройки пароля",
      "notificationSettings": "Настройки уведомлений",
      "fullName": "ФИО",
      "emailAddress": "Email адрес",
      "saveChanges": "Сохранить изменения",
      "accountSettings": "Настройки аккаунта",
      "changePassword": "Изменить пароль",
      "currentPassword": "Текущий пароль",
      "newPassword": "Новый пароль",
      "confirmPassword": "Подтвердите пароль",
      "updatePassword": "Обновить пароль",

      // User Management
      "addUser": "Добавить пользователя",
      "userName": "Имя",
      "userEmail": "Email",
      "userRole": "Роль",
      "actions": "Действия",
      "selectRole": "Выберите роль",
      "manager": "Менеджер",
      "engineer": "Инженер",
      "personnel": "Сотрудник",
      "member": "Сотрудник",

      // Common Actions
      "description": "Описание",
      "active": "Активный",
      "inactive": "Неактивный",
      "yes": "Да",
      "no": "Нет",
      "confirm": "Подтвердить",
      "success": "Успех",
      "error": "Ошибка",
      "add": "Добавить",
      "role": "Роль",

      // Landing Page
      "landing": {
        "features": "Возможности",
        "pricing": "Цены",
        "login": "Вход",
        "start": "Начать",
        "startFree": "Начать бесплатно",
        "cloudBadge": "☁️ Облачное SaaS решение",
        "heroTitle": "Управление проектами",
        "heroSubtitle": "в облаке",
        "heroDescription": "Профессиональная система управления проектами, готовая к использованию без настройки. Начните бесплатно и масштабируйтесь по мере необходимости.",
        "startFreeButton": "Начать бесплатно",
        "discoverFeatures": "Узнать больше",
        "activeUsers": "Активных пользователей",
        "completedProjects": "Завершенных проектов",
        "teamSatisfaction": "Удовлетворенность команды",
        "uptimeRate": "Время безотказной работы",
        "featuresTitle": "Мощные возможности",
        "featuresDescription": "Функции, упрощающие управление проектами и повышающие продуктивность команды",
        "multiUserManagement": "Многопользовательское управление",
        "multiUserManagementDesc": "Комплексная авторизация с ролями: Супервайзер, Админ, Менеджер, Инженер, Сотрудник",
        "multipleViews": "Множество представлений",
        "multipleViewsDesc": "Канбан, Список, Календарь, Временная шкала, Гант - выберите подходящий вид",
        "taskManagement": "Управление задачами",
        "taskManagementDesc": "Подзадачи, зависимости, повторяющиеся задачи, поддержка чек-листов",
        "timesheetTracking": "Учет времени",
        "timesheetTrackingDesc": "Детальный учет времени и отчетность по каждой задаче",
        "reportingAnalytics": "Отчеты и аналитика",
        "reportingAnalyticsDesc": "Мгновенные отчеты и анализ производительности",
        "teamCollaboration": "Командная работа",
        "teamCollaborationDesc": "Комментарии, уведомления, обмен файлами",
        "pricingTitle": "Гибкие цены",
        "pricingDescription": "Начните бесплатно, обновите когда будете готовы",
        "mostPopular": "Самый популярный",
        "perMonth": "в месяц",
        "planFree": "Бесплатный",
        "planProfessional": "Профессиональный",
        "planEnterprise": "Корпоративный",
        "ctaTitle": "Начните цифровую трансформацию сегодня",
        "ctaDescription": "Повысьте продуктивность команды с Milestora. Зарегистрируйтесь и начните управлять первым проектом бесплатно!",
        "tryFree": "Попробовать бесплатно",
        "faqTitle": "Часто задаваемые вопросы",
        "faqDescription": "Вопросы о Milestora",
        "footerDescription": "Профессиональная система управления проектами",
        "quickLinks": "Быстрые ссылки",
        "contact": "Контакты"
      }
    }
  },
  ja: {
    translation: {
      // Common
      "backToHome": "ホームに戻る",
      "back": "戻る",

      // Register Page
      "register": "登録",
      "registerTitle": "今すぐ始める",
      "registerDescription": "アカウントを作成してチームの生産性を向上させましょう",
      "companyName": "会社名",
      "companyNamePlaceholder": "例：Acme ソフトウェア株式会社",
      "industry": "業界",
      "selectIndustry": "業界を選択",
      "nameSurname": "氏名",
      "namePlaceholder": "山田太郎",
      "phoneNumber": "電話番号",
      "phonePlaceholder": "+81 90 1234 5678",
      "phoneHelpText": "国際形式で電話番号を入力してください",
      "passwordHelpText": "6文字以上",
      "registerButton": "アカウント作成",
      "registering": "作成中...",
      "registerSuccess": "登録成功！",
      "registerFailed": "登録に失敗しました",
      "fillAllFields": "すべてのフィールドを入力してください",
      "companyInfo": "会社情報",
      "adminUserInfo": "管理者情報",
      "createCompanyButton": "会社を作成して開始",
      "alreadyHaveAccount": "すでにアカウントをお持ちですか？",
      "loginLink": "ログイン",
      "startInstantly": "今すぐ開始",
      "startInstantlyDesc": "セットアップ不要、すぐに使い始められます",
      "free14Days": "14日間無料",
      "free14DaysDesc": "クレジットカード不要、リスクなし",
      "fullFeatures": "フル機能",
      "fullFeaturesDesc": "すべてのプレミアム機能にフルアクセス",

      // Industries
      "industryTechnology": "テクノロジー",
      "industrySoftware": "ソフトウェア",
      "industryEcommerce": "Eコマース",
      "industryConstruction": "建設",
      "industryManufacturing": "製造",
      "industryHealthcare": "ヘルスケア",
      "industryEducation": "教育",
      "industryFinance": "金融",
      "industryConsulting": "コンサルティング",
      "industryMedia": "メディア",
      "industryTourism": "観光",
      "industryLogistics": "物流",
      "industryRetail": "小売",
      "industryOther": "その他",

      // Header
      "search": "検索...",
      "searchPlaceholder": "プロジェクト、タスク、ドキュメントを検索... (Ctrl+K)",
      "notifications": "通知",
      "settings": "設定",
      "logout": "ログアウト",

      // Search
      "searchResults": "検索結果",
      "noResults": "結果が見つかりません",
      "searchIn": "検索場所",
      "all": "すべて",
      "projects": "プロジェクト",
      "tasks": "タスク",
      "documents": "ドキュメント",

      // Filters
      "filters": "フィルター",
      "advancedFilters": "詳細フィルター",
      "savedFilters": "保存済みフィルター",
      "saveFilter": "フィルターを保存",
      "clearFilters": "フィルターをクリア",
      "applyFilters": "フィルターを適用",
      "filterName": "フィルター名",
      "dateRange": "期間",
      "from": "開始",
      "to": "終了",
      "status": "ステータス",
      "priority": "優先度",
      "assignedTo": "担当者",
      "tags": "タグ",

      // Status
      "status.todo": "未着手",
      "status.in-progress": "進行中",
      "status.done": "完了",
      "todo": "未着手",
      "inProgress": "進行中",
      "done": "完了",

      // Priority
      "priority.low": "低",
      "priority.medium": "中",
      "priority.high": "高",
      "low": "低",
      "medium": "中",
      "high": "高",

      // Task Detail
      "assignedPerson": "担当者",
      "timeSpent": "作業時間",
      "checklist": "チェックリスト",
      "checklistItems": "{{count}}項目",
      "estimatedDates": "予定日",
      "actualDates": "実績日",
      "estimatedStart": "予定開始日",
      "estimatedEnd": "予定終了日",
      "actualStart": "実績開始日",
      "actualEnd": "実績終了日",
      "notSet": "未設定",
      "dateAndTime": "日時",

      // Common
      "cancel": "キャンセル",
      "save": "保存",
      "delete": "削除",
      "edit": "編集",
      "close": "閉じる",
      "apply": "適用",
      "create": "作成",
      "update": "更新",

      // Dashboard
      "dashboard": "ダッシュボード",
      "myProjects": "マイプロジェクト",
      "myTasks": "マイタスク",
      "reports": "レポート",
      "timesheets": "タイムシート",
      "templates": "テンプレート",
      "userManagement": "ユーザー管理",
      "supervisorPanel": "管理者パネル",

      // Mobile
      "menu": "メニュー",
      "openMenu": "メニューを開く",
      "closeMenu": "メニューを閉じる",

      // Project Detail
      "projectDetail": "プロジェクト詳細",
      "newTask": "新規タスク",
      "createTask": "タスク作成",
      "taskTitle": "タスク名",
      "taskDescription": "説明",
      "selectAssignee": "担当者を選択",
      "selectPriority": "優先度を選択",
      "selectStatus": "ステータスを選択",
      "startDate": "開始日",
      "endDate": "終了日",
      "duration": "期間",
      "days": "日",
      "hours": "時間",

      // View Modes
      "kanban": "カンバン",
      "list": "リスト",
      "calendar": "カレンダー",
      "timeline": "タイムライン",
      "gantt": "ガント",

      // Task Card
      "dueDate": "期限",
      "comments": "コメント",
      "attachments": "添付ファイル",

      // Dashboard Stats
      "companyTotalProjects": "会社全体のプロジェクト数",
      "companyProjectsDesc": "会社全体のすべてのプロジェクト",
      "userCreatedProjects": "作成したプロジェクト",
      "projectsYouCreated": "あなたが開始したプロジェクト",
      "userCreatedTasks": "作成したタスク",
      "tasksYouCreated": "あなたが作成したタスク",
      "userAssignedTasks": "割り当てられたタスク",
      "tasksAssignedToYou": "あなたが担当しているタスク",
      "notStarted": "未着手",
      "todoTasks": "まだ開始していないタスク",
      "ongoingTasks": "進行中のタスク",
      "completed": "完了",
      "finishedTasks": "完了したタスク",
      "taskStatus": "タスクステータス",
      "allTasks": "システム内のすべてのタスク",
      "projectProgress": "プロジェクト進捗",
      "recentProjects": "最近のプロジェクトの完了率",

      // Legacy
      "totalProjects": "プロジェクト総数",
      "totalTasks": "タスク総数",
      "assignedToYou": "あなたに割り当て",
      "createdByYou": "あなたが作成",
      "yourProjects": "参加しているプロジェクト数",
      "activeTasks": "アクティブなタスク",
      "tasksCreatedByYou": "あなたが作成したタスク",

      // Projects
      "newProject": "新規プロジェクト",
      "createProject": "プロジェクト作成",
      "projectName": "プロジェクト名",
      "projectDescription": "説明",
      "noProjects": "プロジェクトはまだありません",
      "createdAt": "作成日",

      // Login
      "login": "ログイン",
      "email": "メールアドレス",
      "password": "パスワード",
      "welcomeBack": "おかえりなさい",
      "loginToAccount": "アカウントにログイン",
      "loading": "お待ちください",

      // Settings
      "profileSettings": "プロフィール設定",
      "passwordSettings": "パスワード設定",
      "notificationSettings": "通知設定",
      "fullName": "氏名",
      "emailAddress": "メールアドレス",
      "saveChanges": "変更を保存",
      "accountSettings": "アカウント設定",
      "changePassword": "パスワード変更",
      "currentPassword": "現在のパスワード",
      "newPassword": "新しいパスワード",
      "confirmPassword": "パスワード確認",
      "updatePassword": "パスワードを更新",

      // User Management
      "addUser": "ユーザー追加",
      "userName": "名前",
      "userEmail": "メール",
      "userRole": "役割",
      "actions": "操作",
      "selectRole": "役割を選択",
      "manager": "マネージャー",
      "engineer": "エンジニア",
      "personnel": "スタッフ",
      "member": "スタッフ",

      // Common Actions
      "description": "説明",
      "active": "アクティブ",
      "inactive": "非アクティブ",
      "yes": "はい",
      "no": "いいえ",
      "confirm": "確認",
      "success": "成功",
      "error": "エラー",
      "add": "追加",
      "role": "役割",

      // Landing Page
      "landing": {
        "features": "機能",
        "pricing": "料金",
        "login": "ログイン",
        "start": "開始",
        "startFree": "無料で始める",
        "cloudBadge": "☁️ クラウドベースSaaSソリューション",
        "heroTitle": "プロジェクト管理を",
        "heroSubtitle": "クラウドで",
        "heroDescription": "セットアップ不要ですぐに使えるプロフェッショナルなプロジェクト管理システム。無料で始めて、必要に応じてスケールアップ。",
        "startFreeButton": "無料で始める",
        "discoverFeatures": "機能を見る",
        "activeUsers": "アクティブユーザー",
        "completedProjects": "完了プロジェクト",
        "teamSatisfaction": "チーム満足度",
        "uptimeRate": "稼働率",
        "featuresTitle": "強力な機能",
        "featuresDescription": "プロジェクト管理を簡素化し、チームの生産性を向上させる機能",
        "multiUserManagement": "マルチユーザー管理",
        "multiUserManagementDesc": "スーパーバイザー、管理者、マネージャー、エンジニア、スタッフの役割による包括的な権限管理",
        "multipleViews": "複数のビュー",
        "multipleViewsDesc": "カンバン、リスト、カレンダー、タイムライン、ガント - 最適なビューを選択",
        "taskManagement": "タスク管理",
        "taskManagementDesc": "サブタスク、依存関係、繰り返しタスク、チェックリストサポート",
        "timesheetTracking": "時間追跡",
        "timesheetTrackingDesc": "各タスクの詳細な時間追跡とレポート",
        "reportingAnalytics": "レポートと分析",
        "reportingAnalyticsDesc": "リアルタイムレポートとパフォーマンス分析",
        "teamCollaboration": "チームコラボレーション",
        "teamCollaborationDesc": "コメント、通知、ファイル共有",
        "pricingTitle": "柔軟な料金プラン",
        "pricingDescription": "無料で始めて、準備ができたらアップグレード",
        "mostPopular": "最も人気",
        "perMonth": "月額",
        "planFree": "無料",
        "planProfessional": "プロフェッショナル",
        "planEnterprise": "エンタープライズ",
        "ctaTitle": "今日からデジタルトランスフォーメーションを始めましょう",
        "ctaDescription": "Milestoraでチームの生産性を向上させましょう。今すぐ登録して、最初のプロジェクトを無料で管理し始めましょう！",
        "tryFree": "無料で試す",
        "faqTitle": "よくある質問",
        "faqDescription": "Milestoraについてのよくある質問",
        "footerDescription": "プロフェッショナルなプロジェクト管理システム",
        "quickLinks": "クイックリンク",
        "contact": "お問い合わせ"
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'tr',
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
